/* =========================================================
   Byg din samling (Kort-vælgeren) — mtw-samling.js
   Data: skabelonerne ?view=mtwjson (søgning, kollektion, produkt) giver
     alle varianter med stand, udgave, sprog, pris og lagerantal (højst 4).
     Liste-import finder navne med /search/suggest.json og henter derefter kortet frisk.
   Regler: mtw-samling-core.js (udgaver, stand-grænse, antal, gemt binder).
   Kurv: kernens K.reconcile / K.runCart / K.settle oven på /cart.js og /cart/add.js;
     her er kun netværk, lås og visning.
   Broen (mtw-samling-binder.js) bruger window.MTWC og hændelsen mtwc:added.
   ========================================================= */
(function () {
  "use strict";
  var K = window.MTWCCore; // ren logik: udgaver, stand-grænse, antal (assets/mtw-samling-core.js)
  var root = document.querySelector('[data-mtwc-root]');
  if (!root) return;
  if (!K) { console.error('Kort-vælgeren: mtw-samling-core.js er ikke indlæst, så værktøjet kan ikke starte.'); return; }
  // Bind kun én gang, også hvis scriptet indlæses to gange (overlayet hentes af assets/mtw-kv-loader.js).
  if (window.__mtwcMotor) return;
  window.__mtwcMotor = true;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

  /* ---------- config ---------- */
  var TYPE_TOKENS = (root.getAttribute('data-type-filter') || 'Single').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  var STORE_V2 = 'mtwc-binder-v2', STORE_V1 = 'mtwc-binder-v1', STAND_KEY = 'mtwc-stand', UNDO_MAX = 30;
  var MIN_CHARS = 2, DEBOUNCE = 190;
  var ROOTURL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOTURL.charAt(ROOTURL.length - 1) !== '/') ROOTURL += '/';

  /* ---------- state ---------- */
  var items = [], savedAt = 0, cur = 0, undo = []; // binderen: én række pr. variant (kernens item-form). Side n er items.slice(n * 9, n * 9 + 9)
  var savedRaw = null;                  // den gemte tekst, som fanen sidst læste eller skrev (se sync)
  var busy = false;                     // sandt, mens der lægges i kurven: binderen er låst (se lock), og ændringer fra andre faner læses ikke imens
  var asking = false;                   // sandt fra trykket, til låsen på tværs af faner har svaret (se exclusive)
  var runs = 0;                         // antal kurv-kørsler startet i denne fane (se lock og checkStale)
  var cartChanged = false;              // sandt, når en kørsel har lagt noget i kurven (eller måske, uden svar); overlayet nulstiller ved åbning
  var products = Object.create(null);  // handle -> normaliseret produkt (kernens form); overskrives ved hvert svar
  var lastResults = [], lastTerm = '';  // det, Enter må lægge i: listen og den søgetekst, den hører til
  var drawn = [];                       // produkterne, der står i resultatlisten lige nu
  var waiting = null;                   // en tegning af listen, der venter, fordi et korts stand-vælger har fokus: { prods, term } (se renderResults)
  var gen = 0, searchCtl = null, debT = null;
  var arr = { sort: '', rar: '', ed: '' }; // sortering og filtre i den viste liste ('' = listens standard / alle). Se renderResults
  var limit = 'ALL';                    // stand-grænse: laveste stand, kortets start-valg må have. Uden gemt valg: alle stande
  var chosen = Object.create(null);     // kundens eget valg i kortets stand-vælger: "handle|udgave|sprog" -> variantId. Kun i hukommelsen
  try { limit = validLimit(localStorage.getItem(STAND_KEY)); } catch (e) {}
  var FEATURED_COLL = root.getAttribute('data-featured-coll') || 'pok-mon-single', collCache = {}, collTitle = {};
  var showNumbers = false;       // vis collector-kortnummer på resultat-kort (sæt-mode)
  var onlyStock = false;         // listen lover "på lager" (sæt, chase, tilfældig, illustrator): udsolgte udgaver tegnes ikke
  var allSets = null, setsLoading = false;  // cache af singles-kollektioner til sæt-browser
  // Overlay (sections/mtw-samling-app.liquid, hentet af assets/mtw-kv-loader.js): værktøjet åbnes oven på en anden side med
  // window.MTWC.open(ctx), og luk skjuler det bare. Adressen læses ikke, og der er ingen landingsside.
  var OVERLAY = root.getAttribute('data-mtwc-context') === 'overlay';
  // Direkte link (kun på /pages/byg-samling): det, adressen beder værktøjet åbne med (K.deeplink), ellers null.
  // Sættes til null, når kunden lukker til landingssiden (se hideApp). Broen læser den som window.MTWC.direkte.
  // I overlayet: konteksten fra seneste MTWC.open, til værktøjet lukkes.
  var direkte = root.getAttribute('data-mtwc-context') === 'page' ? K.deeplink(location.search) : null;
  // Måling (spec runde 3, afsnit 4): stedet, værktøjet blev åbnet fra. I overlayet indgangens data-mtwkv (loaderen giver det til
  // MTWC.open og husker det i sessionStorage, mtwc-kilde, resten af besøget). På /pages/byg-samling: side, medmindre siden er
  // åbnet med et direkte link fra butikken selv, og en indgang er husket (loaderen faldt tilbage til indgangens link). Et link
  // udefra (henvisning fra et andet domæne eller ingen) tæller som side, selvom en ældre indgang står husket. Ingen persondata.
  // banner og lancering: topbarens slide og boosterpakken fra lanceringen (snippets/mtw-kv-lancering.liquid).
  var KILDER = ['kollektion', 'kurv', 'produkt', 'soegning', 'menu', 'samlinger', 'banner', 'lancering', 'side'], KILDE_KEY = 'mtwc-kilde';
  function validKilde(k) { return KILDER.indexOf(k) > -1 ? k : ''; }
  function storedKilde() { try { return validKilde(sessionStorage.getItem(KILDE_KEY)); } catch (e) { return ''; } }
  var kilde = OVERLAY ? storedKilde() : (direkte && (document.referrer || '').indexOf(location.origin + '/') === 0 && storedKilde()) || 'side';

  /* ---------- helpers ---------- */
  // Beløb præcist: "12" eller "22,50" (aldrig afrundet til hele kroner). fmtNum uden "kr" bruges, hvor pladsen er trang (stand-chips).
  function fmtNum(kr) {
    var frac = Math.round(kr * 100) % 100 !== 0;
    return kr.toLocaleString('da-DK', { minimumFractionDigits: frac ? 2 : 0, maximumFractionDigits: 2 });
  }
  function fmtKr(kr) { return fmtNum(kr) + ' kr'; }
  // Billedadresse i bredden w. En gammel width (fra mtwjson eller en gemt binder) fjernes først: med to bruger Shopify den
  // første, og adressen er sin egen nøgle i CDN'en, som intet andet har hentet (kold og langsom hver gang).
  function img(url, w) {
    if (!url) return '';
    if (url.slice(0, 2) === '//') url = 'https:' + url;
    var q = url.indexOf('?'), qs = q < 0 ? [] : url.slice(q + 1).split('&').filter(function (s) { return s && s.indexOf('width=') !== 0; });
    qs.push('width=' + (w || 360));
    return (q < 0 ? url : url.slice(0, q)) + '?' + qs.join('&');
  }
  // Kortbillede (63:88) i 360 px overalt: den bredde, temaets kollektionsgitter henter, så CDN'en har den klar (målt: næsten
  // altid HIT). 533 og 720 var kolde (~1,2-1,4 s), og kortet er højst ca. 215 px bredt, så 360 er skarpt nok også på 2x.
  // Samme fil i liste, binder og kvittering: hentes én gang. n: kortets plads i listen; de første EAGER hentes straks
  // (de første 4 med høj prioritet), resten, når de nærmer sig. Uden n: lazy.
  var EAGER = 8;
  function cardImg(url, alt, n) {
    var now = n != null && n < EAGER;
    return '<img src="' + esc(img(url, 360)) + '" width="360" height="503" alt="' + esc(alt) + '"' +
      (now ? (n < 4 ? ' fetchpriority="high"' : '') : ' loading="lazy"') + ' decoding="async">';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function isSingle(type) { type = (type || '').toLowerCase(); return TYPE_TOKENS.some(function (t) { return type.indexOf(t) > -1; }); }

  /* ---------- binderen: lagring og ændringer ---------- */
  function pageCount() { return Math.max(1, Math.ceil(items.length / 9)); }
  // savedAt og savedRaw følger kun det, der faktisk står gemt: kan der ikke skrives, virker binderen videre i denne fane.
  // Første gang det sker, får kunden det at vide (efter den besked, ændringen selv giver).
  // keepTime (30-minutters-kontrollen, når ikke alle kort kunne tjekkes): det gemte tidsstempel bliver stående.
  var storeWarned = false;
  function persist(keepTime) {
    var now = keepTime ? savedAt : Date.now(), raw = K.serialize(items, now);
    try { localStorage.setItem(STORE_V2, raw); savedAt = now; savedRaw = raw; localStorage.removeItem(STORE_V1); } catch (e) {
      if (storeWarned) return;
      storeWarned = true;
      setTimeout(function () { toast('Binderen kan ikke gemmes i denne browser. Den forsvinder, når du lukker siden.', 7000); }, 0);
    }
  }
  // Kernen renser det gemte (og oversætter en gammel v1-binder); ødelagt indhold giver en tom binder.
  function restore() {
    var v2 = null, v1 = null;
    try { v2 = localStorage.getItem(STORE_V2); v1 = localStorage.getItem(STORE_V1); } catch (e) {}
    var d = K.parse(v2, v1, Date.now());
    items = d.items; savedAt = d.t; savedRaw = v2;
    if (cur >= pageCount()) cur = pageCount() - 1;
  }
  // Har en anden fane skrevet, siden vi sidst læste eller skrev? Det afgøres på den gemte TEKST, ikke kun på tidsstemplet:
  // to faner kan skrive i samme millisekund. Så gælder dens binder, og fortryd-stakken, der hørte til den gamle, ryddes.
  // Svarer sandt, når binderen blev skiftet ud. Tegner ikke.
  function sync() {
    var raw = null;
    try { raw = localStorage.getItem(STORE_V2); } catch (e) {}
    if (raw === null || raw === savedRaw) return false; // intet gemt (eller lageret er lukket), eller det gemte er vores eget
    var d = K.parse(raw, null, Date.now());
    items = d.items; savedAt = d.t; savedRaw = raw; undo = []; dropBulkToast();
    if (cur >= pageCount()) cur = pageCount() - 1;
    return true;
  }
  // Eneste sted, binderen ændres. Hver skrivning læser først det gemte (sync), så en anden fanes kort ikke overskrives.
  //   change er en funktion (base) -> ny liste: ændringen lægges oven på den friske base. Brug den til alt, der kan
  //     udtrykkes mod en vilkårlig base (K.add, K.setQty, filter på variantId). Giver den base selv tilbage, skrives intet.
  //   change er en færdig liste: kun gyldig, når basen er uændret (fortryd). Har en anden fane skrevet, skrives intet;
  //     dens binder vises, og kunden får besked.
  //   opts.noUndo: intet fortryd-trin. opts.silent: gem uden at tegne (liste-import tegner én gang til sidst).
  //   opts.fromRun: kaldet kommer fra kurv-kørslen selv; alle andre kald ignoreres, mens busy er sand.
  //   opts.keepTime: binderens tidsstempel ændres ikke (se persist).
  // Svarer sandt, når der blev skrevet.
  function commit(change, opts) {
    opts = opts || {};
    if (busy && !opts.fromRun) return false;
    var moved = sync(), isFn = typeof change === 'function';
    if (moved && !isFn) { render(); toast('Binderen blev ændret i en anden fane. Prøv igen.'); return false; }
    var next = isFn ? change(items) : change;
    if (!Array.isArray(next) || next === items) { if (moved) render(); return false; }
    if (!opts.noUndo) { undo.push(items); if (undo.length > UNDO_MAX) undo.shift(); }
    items = next;
    dropBulkToast(); // Fortryd i "Læg alle"-beskeden gælder kun, til binderen ændres igen
    if (cur >= pageCount()) cur = pageCount() - 1;
    persist(opts.keepTime);
    if (!opts.silent) render();
    return true;
  }
  // En anden fane har ændret binderen: vis dens udgave. Under en kurv-kørsel ventes der, til låsen slippes (se lock).
  function follow() { if (!busy && sync()) render(); }
  window.addEventListener('storage', function (e) { if (e.key === STORE_V2) follow(); });
  // Siden kommer frem igen (tilbage fra kurven via bfcache, eller fanen bliver synlig): læs det gemte.
  // En kvittering, der stod åben, da kunden gik til kurven, lukkes, så værktøjet bag den ikke bliver ved med at være spærret.
  window.addEventListener('pageshow', function (e) { if (e.persisted) { closeReceipt(); follow(); } });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') follow(); });

  /* ---------- produkter, udgaver og stand-grænse (reglerne ligger i kernen) ---------- */
  // Cachen overskrives altid: det senest hentede er det, et tryk lægger i.
  function remember(raw) { var p = K.normalize(raw); products[p.handle] = p; return p; }
  function tileOf(handle, key) {
    var p = products[handle], ts = p ? K.tiles(p) : [];
    for (var i = 0; i < ts.length; i++) if (ts[i].key === key) return ts[i];
    return null;
  }
  function inStock(p) { return p.variants.some(function (v) { return v.available; }); }
  // Rå produkter fra en mtwjson-visning -> normaliserede enkeltkort.
  function singles(raw) { return raw.map(remember).filter(function (p) { return isSingle(p.type); }); }
  // Kun kendte nøgler. Intet gemt eller en ukendt tekst giver "Alle".
  function validLimit(key) { return K.LIMITS.some(function (l) { return l.key === key; }) ? key : 'ALL'; }
  // Liste-import vælger selv stand. Sætningen står i modalen og i resultatlinjen og følger stand-grænsen.
  function pickText() { return 'Vi vælger den billigste stand inden for din stand-grænse: ' + K.limitOf(limit).name + '.'; }
  function paintLimit() {
    var sel = $('[data-mtwc-limitsel]'), txt = $('[data-mtwc-pastepick]');
    if (sel) sel.value = limit;
    if (txt) txt.textContent = pickText();
  }
  // Ny stand-grænse: gemmes, valgene på de enkelte kort nulstilles, og den viste liste tegnes igen uden netværkskald.
  // Liste-importens resultat (sætningen om stand og kortene i afklar-køen) følger med.
  function setLimit(key) {
    limit = validLimit(key);
    chosen = Object.create(null);
    try { localStorage.setItem(STAND_KEY, limit); } catch (e) {}
    paintLimit();
    redraw();
    renderClarify();
  }

  /* ---------- ind i binderen ---------- */
  // Loftet på 4 pr. kort eller lageret? max er kortets lagerantal i data (højst K.MAX_QTY).
  function maxText(max) {
    return max >= K.MAX_QTY ? 'Du kan højst lægge ' + K.MAX_QTY + ' af samme kort i binderen' : 'Der er ikke flere på lager af det kort i den stand';
  }
  var FULL_TEXT = 'Binderen er fuld (' + K.CAP + ' kort). Læg den i kurven, og fortsæt i en ny.';
  // SOLD_TEXT kun, når varianten faktisk ikke er på lager. Viser kortet bare noget andet end de friske data, bruges MOVED_TEXT.
  var SOLD_TEXT = 'Den stand er lige blevet solgt', MOVED_TEXT = 'Kortet er opdateret. Tjek standen.';
  // Fra 225 kort: hvor mange der er plads til endnu ('' før det).
  function roomText(n) {
    var left = K.CAP - n;
    return n >= K.WARN_AT ? (left === 1 ? '1 plads tilbage' : left + ' pladser tilbage') : '';
  }
  // Eneste vej ind i binderen: netop den udgave og variant, der er trykket på (resultatliste, Enter, afklaring, liste-import).
  // Samme variant igen giver én mere (højst lagerantallet). opts.silent (liste-import): ingen besked, ingen tegning, ingen hændelse.
  function addVariant(tile, variant, opts) {
    if (busy) return false; // binderen er låst, mens den lægges i kurven (gælder også en liste-import, der er i gang)
    var silent = !!(opts && opts.silent), r = null;
    commit(function (base) {
      r = K.add(base, K.makeItem(tile, variant));
      if (!silent && (r.result === 'added' || r.result === 'inc')) cur = Math.floor(r.index / 9); // vis siden, kortet ligger på
      return r.items;
    }, silent ? { silent: true, noUndo: opts.noUndo } : null);
    if (!r) return false;
    if (r.result === 'full') { if (!silent) toast(FULL_TEXT); return false; }
    if (r.result === 'max') { if (!silent) toast(maxText(variant.qty)); return false; }
    if (silent) return true;
    var it = r.items[r.index], d = K.describe(it), room = roomText(K.count(r.items));
    toast('Lagt i binder: ' + esc(it.title) + (d ? ' · ' + esc(d) : '') + (room ? ' · ' + room : ''));
    // Broen (mtw-samling-binder.js) lytter på denne i stedet for at læse motorens lager.
    document.dispatchEvent(new CustomEvent('mtwc:added', { detail: { handle: it.handle, title: it.title, variantId: it.variantId, ed: it.ed, lang: it.lang } }));
    return true;
  }

  /* ---------- listekald: kun det seneste må tegne ---------- */
  // Søgning, sæt, illustrator, chase, tilfældig og forside starter alle her. isCurrent() er falsk, så snart et nyere kald er startet.
  function loadList(fn) {
    var mine = ++gen;
    clearTimeout(debT); // en ventende søgning må ikke starte oven i det nye kald
    if (searchCtl) { searchCtl.abort(); searchCtl = null; }
    lastResults = []; lastTerm = '';
    arr.rar = arr.ed = ''; // en ny liste nulstiller filtrene; sorteringen beholdes, hvis listen har den
    fn(function () { return mine === gen; });
  }
  // Én side af en mtwjson-visning ({page, more, products}); null ved fejlsvar.
  // Uden Accept-header: ellers svarer Shopify med sit eget JSON og ignorerer ?view=mtwjson.
  function fetchPage(url, signal) {
    return fetch(ROOTURL + url, signal ? { signal: signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return d && Array.isArray(d.products) ? d : null; });
  }
  // Side 1..maxPages samlet til { raw: rå produkter, whole: alt blev hentet, title: kollektionens navn ('' uden) }.
  // Afvises kun, hvis side 1 fejler; fejler en senere side, eller er kaldet forældet, gives det hentede med whole = false.
  // onFirst(raw, title) kaldes efter side 1, når der er flere sider på vej, så listen kan tegnes straks.
  function fetchPaged(urlForPage, maxPages, isCurrent, onFirst) {
    var acc = [], title = '';
    function page(n) {
      return fetchPage(urlForPage(n)).then(function (d) {
        if (!isCurrent()) return { raw: acc, whole: false, title: title };
        if (!d) throw new Error('mtwjson');
        if (n === 1 && typeof d.title === 'string') title = d.title;
        acc = acc.concat(d.products);
        if (!d.more || n >= maxPages) return { raw: acc, whole: true, title: title };
        if (n === 1 && onFirst) onFirst(acc, title);
        return page(n + 1);
      }).catch(function (e) {
        if (n === 1) throw e;
        return { raw: acc, whole: false, title: title };
      });
    }
    return page(1);
  }

  /* ---------- search (fuld JSON-visning: ALLE matches, ikke predictive-loft på 10) ---------- */
  function search(term) {
    term = (term || '').trim();
    loadList(function (isCurrent) {
      showNumbers = false; onlyStock = false;
      if (term.length < MIN_CHARS) { setView(''); showHint('Skriv for at søge blandt vores enkeltkort …'); return; }
      setView('Søgning:', term);
      searchCtl = ('AbortController' in window) ? new AbortController() : null;
      setLoading(true);
      var ctl = searchCtl, acc = [], seen = Object.create(null), MAXPAGES = 5;
      function draw(done) {
        lastResults = acc; lastTerm = term;
        if (acc.length) renderResults(acc, term);
        else if (done) showHint('Ingen enkeltkort matcher “' + term + '”.');
      }
      function page(n) {
        fetchPage('search?type=product&view=mtwjson&q=' + encodeURIComponent(term + '*') + '&page=' + n, ctl && ctl.signal)
          .then(function (d) {
            if (!isCurrent() || $('[data-mtwc-input]').value.trim() !== term) return; // forældet
            if (!d && !acc.length) { showHint('Kunne ikke søge lige nu.'); return; }
            (d ? d.products : []).forEach(function (raw) {
              if (seen[raw.handle]) return;
              seen[raw.handle] = 1;
              var p = remember(raw);
              if (isSingle(p.type)) acc.push(p);
            });
            var done = !d || !d.more || n >= MAXPAGES;
            if (n === 1 || done) draw(done);      // tegn straks efter side 1, og igen når alt er hentet
            if (!done) page(n + 1);
          })
          .catch(function (e) {
            if ((e && e.name === 'AbortError') || !isCurrent()) return;
            if (acc.length) draw(true); else showHint('Kunne ikke søge lige nu.');
          });
      }
      page(1);
    });
  }
  function setLoading(on) {
    var host = $('[data-mtwc-results]'), hint = $('[data-mtwc-searchhint]');
    if (on) { hint.hidden = true; drawn = []; waiting = null; host.innerHTML = '<li class="mtwc-loading"><span class="mtwc-spin"></span>Søger …</li>'; paintArrange(null); }
  }
  function showHint(msg) { drawn = []; waiting = null; $('[data-mtwc-searchhint]').textContent = msg; $('[data-mtwc-searchhint]').hidden = false; $('[data-mtwc-results]').innerHTML = ''; paintArrange(null); }

  /* ---------- det, listen viser: "Viser: 30th Celebration · 87 kort ✕" over listen ---------- */
  // pre '' skjuler den (forsiden). n: antal viste kort efter filtrene (udelades, mens listen hentes; se renderResults).
  // ✕ (se klik nedenfor) giver forsiden med alle kort, tømmer søgefeltet, slukker chippen og nulstiller sortering og filtre.
  var view = { pre: '', name: '' };
  function setView(pre, name, n) {
    var el = $('[data-mtwc-view]'), cnt = el && $('[data-mtwc-viewn]', el);
    view = { pre: pre || '', name: name || '' };
    if (!el) return;
    el.hidden = !pre;
    if (pre) $('[data-mtwc-viewlbl]', el).innerHTML = '<span class="mtwc-view-p">' + esc(pre) + '</span> <b>' + esc(name || '') + '</b>';
    if (cnt) { cnt.hidden = n == null; cnt.textContent = n == null ? '' : '· ' + n + ' kort'; }
  }
  function clearView() {
    var inp = $('[data-mtwc-input]'), kb = keyFocus(); // med tastatur: fokus i søgefeltet, ellers intet tastatur på telefonen
    arr = { sort: '', rar: '', ed: '' };
    inp.value = '';
    showFeatured();
    if (kb) inp.focus();
  }

  /* ---------- featured / kollektion (forside i værktøjet) ---------- */
  function setChipActive(el) {
    $$('.mtwc-gchip').forEach(function (b) { var on = b === el; b.classList.toggle('mtwc-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  // Forsiden henter 1 side; et sæt (opts.numbered) henter hele sættet og viser kun kort på lager, sorteret efter kortnummer.
  // opts.name: sættets navn til "Viser: …"; ellers kollektionens eget navn fra svaret (collTitle).
  function loadCollection(handle, chipEl, opts) {
    var setMode = !!(opts && opts.numbered), key = handle + '|' + (setMode ? 'set' : 'feat');
    if (opts && opts.name) collTitle[handle] = opts.name;
    var front = !setMode && handle === FEATURED_COLL, named = collTitle[handle] || ''; // front: forsiden, uden "Viser: …"
    loadList(function (isCurrent) {
      showNumbers = onlyStock = setMode;
      if (front) setView('');
      else setView('Viser:', named || (setMode ? 'Sæt' : 'Kollektion'));
      function title(t) { // navnet fra svaret, når det ikke var kendt
        if (front || !t || named || !isCurrent()) return;
        named = collTitle[handle] = cleanSetName(t);
        setView('Viser:', named);
      }
      function shape(raw) {
        var prods = singles(raw);
        if (!setMode) return prods;
        return K.arrange(prods.filter(inStock), { sort: 'nr' }); // kortnummer som kernen læser det (K.cardCode)
      }
      function draw(prods) {
        lastResults = prods;
        if (!prods.length) { showHint(setMode ? 'Ingen kort på lager i dette sæt lige nu.' : 'Ingen enkeltkort her lige nu.'); return; }
        renderResults(prods, '');
        if (chipEl) setChipActive(chipEl);
      }
      if (collCache[key]) { draw(collCache[key]); return; }
      setLoading(true);
      // Tegn straks efter side 1 og igen, når hele sættet er hentet. Kun et helt sæt gemmes i cachen.
      fetchPaged(function (n) { return 'collections/' + handle + '?view=mtwjson&page=' + n; }, setMode ? 12 : 1, isCurrent,
        function (raw, t) { title(t); var first = shape(raw); if (first.length) draw(first); })
        .then(function (res) {
          if (!isCurrent()) return;
          title(res.title);
          var prods = shape(res.raw);
          if (res.whole) collCache[key] = prods;
          else if (!prods.length) { showHint('Kunne ikke hente kort.'); return; }
          draw(prods);
        })
        .catch(function () { if (isCurrent()) showHint('Kunne ikke hente kort.'); });
    });
  }
  function showFeatured() {
    setChipActive(null); // forsiden har ingen chip: ingen er markeret
    loadCollection(FEATURED_COLL, null);
  }

  /* ---------- sæt-browser (master set) ---------- */
  function gameOf(title) {
    var t = (title || '').toLowerCase();
    if (t.indexOf('one piece') > -1) return 'One Piece';
    if (t.indexOf('riftbound') > -1) return 'Riftbound';
    if (t.indexOf('pok') > -1) return 'Pokémon';
    if (t.indexOf('lorcana') > -1) return 'Lorcana';
    if (t.indexOf('yu-gi') > -1 || t.indexOf('yugioh') > -1) return 'Yu-Gi-Oh!';
    if (t.indexOf('digimon') > -1) return 'Digimon';
    if (t.indexOf('magic') > -1 || t.indexOf('mtg') > -1) return 'Magic';
    if (t.indexOf('flesh and blood') > -1) return 'Flesh & Blood';
    return '';
  }
  function cleanSetName(title) {
    var n = (title || '')
      .replace(/\s*[-–—]\s*singles?\s*$/i, '')
      .replace(/\bsingles?\b/ig, '')
      .replace(/tcg\s*[:\-–]?\s*/ig, '')
      .replace(/\s*[-–—:]\s*$/, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
    // fjern ledende spilnavn (vises som tag) — undgå fx "Pokémon Pokémon Obsidian Flames"
    var stripped = n.replace(/^(pok[eé]mon|one piece|riftbound|lorcana|yu-?gi-?oh!?|digimon|magic(:? the gathering)?|flesh (and|&) blood)\s+/i, '').trim();
    return stripped.length > 1 ? stripped : n;
  }
  function loadSets() {
    if (allSets || setsLoading) { renderSetList(); return; }
    setsLoading = true;
    var acc = [];
    function page(n) {
      fetch(ROOTURL + 'collections.json?limit=250&page=' + n, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { collections: [] }; })
        .then(function (d) {
          var cs = d.collections || [];
          acc = acc.concat(cs);
          if (cs.length === 250 && n < 4) { page(n + 1); return; }
          // kun singles-kollektioner (sæt), ryd op + sortér
          allSets = acc.filter(function (c) { return /singles?/i.test(c.title || ''); })
            .map(function (c) { return { handle: c.handle, title: c.title, name: cleanSetName(c.title), game: gameOf(c.title), pub: c.published_at || c.updated_at || '' }; })
            .filter(function (c) { return c.name.length > 1; })
            .sort(function (a, b) { return a.name.localeCompare(b.name); });
          setsLoading = false;
          renderSetList();
        })
        .catch(function () { setsLoading = false; var el = $('[data-mtwc-setlist]'); if (el) el.innerHTML = '<div class="mtwc-sethint">Kunne ikke hente sæt lige nu.</div>'; });
    }
    page(1);
  }
  function renderSetList() {
    var host = $('[data-mtwc-setlist]'); if (!host) return;
    if (setsLoading || !allSets) { host.innerHTML = '<div class="mtwc-setloading"><span class="mtwc-spin"></span>Henter sæt …</div>'; return; }
    var q = ($('[data-mtwc-setinput]').value || '').trim().toLowerCase();
    var list = allSets;
    if (q) list = allSets.filter(function (c) { return (c.name + ' ' + c.game).toLowerCase().indexOf(q) > -1; });
    if (!list.length) { host.innerHTML = '<div class="mtwc-sethint">Ingen sæt matcher “' + esc(q) + '”.</div>'; return; }
    var capped = list.slice(0, 80);
    host.innerHTML = capped.map(function (c) {
      return '<button type="button" class="mtwc-setrow" data-setrow="' + esc(c.handle) + '">' +
        (c.game ? '<span class="mtwc-setgame">' + esc(c.game) + '</span>' : '') +
        '<span class="mtwc-setname">' + esc(c.name) + '</span>' +
        '<span class="mtwc-setgo" aria-hidden="true">→</span></button>';
    }).join('') + (list.length > capped.length ? '<div class="mtwc-sethint">Søg for at indsnævre. ' + list.length + ' sæt i alt.</div>' : '');
  }
  function openSetBrowser() {
    var chip = $('[data-mtwc-setbrowse]'); if (chip) setChipActive(chip);
    $('[data-mtwc-modal="sets"]').hidden = false;
    var inp = $('[data-mtwc-setinput]');
    renderSetList();
    loadSets();
    setTimeout(function () { try { inp.focus(); } catch (e) {} }, 30);
  }
  function pickSet(handle, name) {
    $('[data-mtwc-modal="sets"]').hidden = true;
    $('[data-mtwc-input]').value = '';
    loadCollection(handle, $('[data-mtwc-setbrowse]'), { numbered: true, name: name });
    if (name) toast('Sæt: <b>' + esc(name) + '</b>, sorteret efter kortnummer');
  }


  /* ---------- illustrator-browser (pokemontcg-artist via portalens card-lookup) ---------- */
  var allArtists = null, artistsLoading = false;
  var ARTIST_API = 'https://tradein.matraws.dk/api/card-lookup?artists=1';
  var ILLU_COLL = 'pok-mon-single';
  function loadArtists() {
    if (allArtists || artistsLoading) { renderArtistList(); return; }
    artistsLoading = true;
    fetch(ARTIST_API).then(function (r) { return r.json(); })
      .then(function (d) {
        allArtists = (d.artists || []).filter(function (a) { return a.artist; });
        artistsLoading = false;
        renderArtistList();
      })
      .catch(function () { artistsLoading = false; var el = $('[data-mtwc-artistlist]'); if (el) el.innerHTML = '<div class="mtwc-sethint">Kunne ikke hente illustratorer lige nu.</div>'; });
  }
  function renderArtistList() {
    var host = $('[data-mtwc-artistlist]'); if (!host) return;
    if (artistsLoading || !allArtists) { host.innerHTML = '<div class="mtwc-setloading"><span class="mtwc-spin"></span>Henter illustratorer \u2026</div>'; return; }
    if (!allArtists.length) { host.innerHTML = '<div class="mtwc-sethint">Illustrator-data er p\u00e5 vej. Kig forbi igen i morgen.</div>'; return; }
    var q = ($('[data-mtwc-artistinput]').value || '').trim().toLowerCase();
    // Vis LAGER-tal (Mathias): katalog-antal ("407 kort") forvirrede når kun 113 var på lager.
    // stock=null: endnu ikke talt (vises uden tal); stock=0: skjules helt.
    var list = allArtists.filter(function (a) { return a.stock !== 0; });
    // Flest på lager øverst (opdagelse > alfabet — søgefeltet dækker navnekendere);
    // utalte (stock=null) nederst, alfabetisk indbyrdes.
    list = list.slice().sort(function (a, b) {
      var as = (typeof a.stock === 'number') ? a.stock : -1;
      var bs = (typeof b.stock === 'number') ? b.stock : -1;
      return bs - as || a.artist.localeCompare(b.artist);
    });
    if (q) list = list.filter(function (a) { return a.artist.toLowerCase().indexOf(q) > -1; });
    if (!list.length) { host.innerHTML = '<div class="mtwc-sethint">Ingen illustratorer matcher \u201c' + esc(q) + '\u201d.</div>'; return; }
    var capped = list.slice(0, 80);
    host.innerHTML = capped.map(function (a) {
      return '<button type="button" class="mtwc-setrow" data-artistrow="' + esc(a.artist) + '">' +
        '<span class="mtwc-setname">' + esc(a.artist) + '</span>' +
        (typeof a.stock === 'number' ? '<span class="mtwc-setgame">' + a.stock + ' på lager</span>' : '') +
        '<span class="mtwc-setgo" aria-hidden="true">\u2192</span></button>';
    }).join('') + (list.length > capped.length ? '<div class="mtwc-sethint">S\u00f8g for at indsn\u00e6vre. ' + list.length + ' illustratorer i alt.</div>' : '');
  }
  function openArtistBrowser() {
    var chip = $('[data-mtwc-artistbrowse]'); if (chip) setChipActive(chip);
    $('[data-mtwc-modal="artists"]').hidden = false;
    renderArtistList();
    loadArtists();
    setTimeout(function () { try { $('[data-mtwc-artistinput]').focus(); } catch (e) {} }, 30);
  }
  // Shopifys tag-URL-handle kan bevare underscore eller ej alt efter version — prøv begge.
  function artistTagHandles(name) {
    var base = ('illustrator_' + name).toLowerCase();
    return [
      base.replace(/[^a-z0-9_]+/g, '-').replace(/^-+|-+$/g, ''),
      base.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
    ].filter(function (v, i, arr) { return arr.indexOf(v) === i; });
  }
  function pickArtist(name) {
    $('[data-mtwc-modal="artists"]').hidden = true;
    $('[data-mtwc-input]').value = '';
    var handles = artistTagHandles(name);
    loadList(function (isCurrent) {
      showNumbers = false; onlyStock = true;
      setView('Illustrator:', name);
      setLoading(true);
      var failed = false;
      function draw(prods) {
        lastResults = prods;
        renderResults(prods, name);
        var chip = $('[data-mtwc-artistbrowse]'); if (chip) setChipActive(chip);
      }
      function tryHandle(hi) {
        if (hi >= handles.length) { showHint(failed ? 'Kunne ikke hente kort.' : 'Ingen kort på lager fra ' + name + ' lige nu.'); return; }
        // Tegn straks efter side 1 og igen, når alle sider er hentet.
        fetchPaged(function (n) { return 'collections/' + ILLU_COLL + '/' + handles[hi] + '?view=mtwjson&page=' + n; }, 6, isCurrent,
          function (raw) { var first = singles(raw).filter(inStock); if (first.length) draw(first); })
          .then(function (res) {
            if (!isCurrent()) return;
            if (!res.raw.length) { tryHandle(hi + 1); return; }
            var prods = singles(res.raw).filter(inStock);
            if (!prods.length) { lastResults = []; showHint(res.whole ? 'Ingen kort på lager fra ' + name + ' lige nu.' : 'Kunne ikke hente kort.'); return; }
            draw(prods);
            toast('Illustrator: <b>' + esc(name) + '</b>');
          }, function () { if (!isCurrent()) return; failed = true; tryHandle(hi + 1); })
          .catch(function () { if (isCurrent()) showHint('Kunne ikke hente kort.'); });
      }
      tryHandle(0);
    });
  }

  /* ---------- nørde-genveje: chase-kort, overrask mig, nyeste sæt ---------- */
  function showChase(chipEl) {
    $('[data-mtwc-input]').value = '';
    loadList(function (isCurrent) {
      showNumbers = false; onlyStock = true;
      setView('Viser:', 'Chase-kort');
      setLoading(true);
      // De allerdyreste er typisk solgt (og står som udsolgte) — så vi bladrer
      // dyrest-først og samler kort PÅ LAGER, til vi har en pæn håndfuld.
      var acc = [];
      function draw() {
        if (!acc.length) return false;
        lastResults = acc;
        renderResults(acc, '');
        if (chipEl) setChipActive(chipEl);
        return true;
      }
      function page(n) {
        fetchPage('collections/' + FEATURED_COLL + '?view=mtwjson&sort_by=price-descending&page=' + n)
          .then(function (d) {
            if (!isCurrent()) return;
            if (!d) { if (!draw()) showHint('Kunne ikke hente kort.'); return; }
            acc = acc.concat(singles(d.products).filter(inStock));
            if (acc.length < 24 && d.more && n < 10) { page(n + 1); return; }
            if (draw()) toast('<b>Chase-kort</b>: de dyreste enkeltkort på lager lige nu');
            else showHint('Ingen kort lige nu.');
          }, function () { if (isCurrent() && !draw()) showHint('Kunne ikke hente kort.'); })
          .catch(function () { if (isCurrent()) showHint('Kunne ikke hente kort.'); });
      }
      page(1);
    });
  }
  function showRandom(chipEl, attempt) {
    attempt = attempt || 0;
    $('[data-mtwc-input]').value = '';
    loadList(function (isCurrent) {
      showNumbers = false; onlyStock = true;
      setView('Viser:', 'Tilfældigt udvalg');
      setLoading(true);
      // Tilfældig side i singles-kollektionen; tom side (uden for sidste) -> prøv snævrere.
      var maxPage = attempt === 0 ? 200 : attempt === 1 ? 60 : 12;
      var page = 1 + Math.floor(Math.random() * maxPage);
      fetchPaged(function () { return 'collections/' + FEATURED_COLL + '?view=mtwjson&page=' + page; }, 1, isCurrent)
        .then(function (res) {
          if (!isCurrent()) return;
          var prods = singles(res.raw).filter(inStock);
          if (!prods.length) { if (attempt < 3) { showRandom(chipEl, attempt + 1); } else { showHint('Terningen drillede. Prøv igen.'); } return; }
          lastResults = prods;
          renderResults(prods, '');
          if (chipEl) setChipActive(chipEl);
          toast('<b>Overrask mig</b>: et tilfældigt udvalg fra samlingen');
        })
        .catch(function () { if (isCurrent()) showHint('Kunne ikke hente kort.'); });
    });
  }
  function showNewestSet(chipEl) {
    loadList(function (isCurrent) {
      setView('Viser:', 'Nyeste sæt');
      function go() {
        var best = null;
        allSets.forEach(function (c) { if (c.pub && (!best || c.pub > best.pub)) best = c; });
        if (!best) { showHint('Kunne ikke finde nyeste sæt.'); return; }
        $('[data-mtwc-input]').value = '';
        loadCollection(best.handle, chipEl, { numbered: true, name: best.name });
        toast('Nyeste sæt: <b>' + esc(best.name) + '</b>');
      }
      if (allSets) { go(); return; }
      setLoading(true);
      loadSets(); // fylder allSets (modalen er skjult; render er no-op udadtil)
      var tries = 0;
      var iv = setInterval(function () {
        if (!isCurrent()) { clearInterval(iv); return; }
        if (allSets) { clearInterval(iv); go(); }
        else if (++tries > 40) { clearInterval(iv); showHint('Kunne ikke hente sæt lige nu.'); }
      }, 200);
    });
  }

  /* ---------- resultatkort: ét pr. udgave + sprog ---------- */
  // Antal i binderen af netop denne udgave (key = "udgave|sprog", som kernens tile.key).
  function inBinder(handle, key) {
    var n = 0;
    items.forEach(function (it) { if (it.handle === handle && it.ed + '|' + it.lang === key) n += it.qty; });
    return n;
  }
  // Standens navn ('' for kort uden stand, fx gradede).
  function standName(v) { return v.hasCond === false || !v.cond ? '' : v.cond; }
  // "Near Mint, 12 kr" (kun prisen for kort uden stand).
  function variantLabel(v) { var n = standName(v); return (n ? n + ', ' : '') + fmtKr(v.price); }
  // Det, kortet viser som valgt, og som et tryk lægger i: kundens eget valg i kortets vælger, så længe netop den variant
  // står i udgavens oversigt (på lager); ellers den billigste inden for stand-grænsen. sum er K.standSummary(tile).
  // Et valg, der ikke længere er på lager, bortfalder. Der vælges aldrig på tværs af udgave eller sprog (tile er én udgave).
  function choiceOf(tile, sum) {
    var k = tile.handle + '|' + tile.key, id = chosen[k];
    if (id != null) {
      for (var i = 0; i < sum.length; i++) if (String(sum[i].id) === String(id)) return sum[i];
      delete chosen[k];
    }
    return K.pick(tile, limit);
  }
  // Kortets tilstand ud fra de friske data: sum (stande på lager, bedst først), v (det valgte; null = intet valg endnu),
  // outside (på lager, men intet inden for stand-grænsen og intet eget valg) og teksten på "+".
  function tileView(tile) {
    var sum = K.standSummary(tile), v = choiceOf(tile, sum);
    return { sum: sum, v: v, outside: !v && sum.length > 0,
      addLbl: v ? 'Læg i binder: ' + variantLabel(v) : sum.length ? 'Vælg først en stand under kortet' : 'Udsolgt' };
  }
  // Rækkens synlige tekst (.mtwc-rprice): "Near Mint · 30 kr" og en kort udgave ("NM · 30 kr"); CSS viser den korte,
  // når den lange ikke kan være der, så prisen aldrig klippes. Uden valg: "Vælg stand". Broen læser prisen her.
  // En stand uden for skalaen (fx "Heavily Damaged") har ingen forkortelse: navnet står fuldt ud og klippes med "…",
  // mens prisen altid står helt. Det fulde navn og prisen står også i rækkens title (se tileHTML og paintTile).
  function faceHTML(v) {
    if (!v) return '<span class="mtwc-pf">Vælg stand</span>';
    var name = standName(v), a = K.abbr(v), kr = '<b>' + fmtKr(v.price) + '</b>';
    if (!name) return '<span class="mtwc-pf">' + kr + '</span>';
    if (K.rank(v.cond) >= K.STANDS.length) return '<span class="mtwc-pf mtwc-pf--full"><span class="mtwc-pn">' + esc(name) + '</span><span class="mtwc-pp">\u00a0· ' + kr + '</span></span>';
    return '<span class="mtwc-pf">' + esc(name) + ' · ' + kr + '</span>' +
      (a && a !== name ? '<span class="mtwc-pa" aria-hidden="true">' + esc(a) + ' · ' + kr + '</span>' : '');
  }
  // Ét resultatkort: billede med "+" og mærkater, titel og ÉN række (.mtwc-buy) i fast højde:
  //   flere stande på lager (eller kun stande uden for grænsen): en rigtig <select data-standsel> med alle stande og priser;
  //   én stand på lager inden for grænsen: ren tekst; intet på lager: "Udsolgt".
  // data-pick er den variant, kortet viser som valgt ('' = intet valg). Et tryk på kortet eller "+" lægger netop den i (se addShown).
  function tileHTML(tile, n) {
    var s = tileView(tile), v = s.v, title = esc(tile.title);
    var h = esc(tile.handle), nb = inBinder(tile.handle, tile.key);
    var media = tile.image ? cardImg(tile.image, '', n) : '<span class="mtwc-ph">🃏</span>';
    var badges = (tile.edLabel ? edBadge(tile.edLabel) : '') +
      (tile.langLabel ? '<span class="mtwc-badge lang">' + esc(tile.langLabel) + '</span>' : '') +
      (tile.available ? '' : '<span class="mtwc-badge so">Udsolgt</span>');
    var pickAttr = v ? ' data-pickadd' : '', rowTitle = v ? ' title="' + esc(variantLabel(v)) + '"' : '', buy;
    if (!s.sum.length) {
      buy = '<div class="mtwc-buy mtwc-buy--so"><span class="mtwc-soldout-lbl">Udsolgt</span></div>';
    } else if (s.sum.length === 1 && v) {
      buy = '<div class="mtwc-buy mtwc-buy--one"' + rowTitle + '><span class="mtwc-rprice">' + faceHTML(v) + '</span></div>';
    } else {
      // Vælgeren ligger usynlig oven på teksten: tastatur, skærmlæser og telefonens egen vælger virker, og teksten kan vise prisen helt.
      buy = '<div class="mtwc-buy mtwc-buy--sel"' + rowTitle + '><span class="mtwc-rprice" aria-hidden="true">' + faceHTML(v) + '</span>' +
        '<select class="mtwc-standsel" data-standsel aria-label="Stand for ' + title + '">' +
        (v ? '' : '<option value="" disabled selected hidden>Vælg stand</option>') +
        s.sum.map(function (o) {
          var n = standName(o);
          return '<option value="' + esc(String(o.id)) + '"' + (v && o.id === v.id ? ' selected' : '') + '>' + esc((n ? n + ' · ' : '') + fmtKr(o.price)) + '</option>';
        }).join('') + '</select></div>';
    }
    return '<li class="mtwc-result' + (s.outside ? ' mtwc-result--outside' : '') + '" data-handle="' + h + '" data-tile="' + esc(tile.key) + '" data-pick="' + (v ? esc(String(v.id)) : '') + '">' +
      (nb ? '<span class="mtwc-inb">×' + nb + '</span>' : '') +
      '<button type="button" class="mtwc-add"' + (v ? pickAttr : ' disabled') + ' title="' + esc(s.addLbl) + '" aria-label="' + esc(s.addLbl) + '">+</button>' +
      '<div class="mtwc-card"' + pickAttr + '>' + (badges ? '<span class="mtwc-badges">' + badges + '</span>' : '') + media + cardNoHTML(tile) + '</div>' +
      '<div class="mtwc-rname">' + title + '</div>' + buy +
      '</li>';
  }
  // Kortnummeret på billedet (kun i et sæt), som kernen læser det: "#130", "#TG06", "#BS 4".
  function cardNoHTML(tile) { var c = showNumbers ? K.cardCode(tile.title) : null; return c ? '<span class="mtwc-cardno">#' + esc(c.label) + '</span>' : ''; }
  // De tegnede resultatkort for én udgave. Samme produkt kan stå flere gange i en liste.
  function drawnTiles(handle, key) {
    return $$('.mtwc-result', $('[data-mtwc-results]')).filter(function (li) { return li.getAttribute('data-handle') === handle && li.getAttribute('data-tile') === key; });
  }
  // Et valg i kortets vælger retter kortet på stedet (listen tegnes ikke igen: telefonens vælger kan stadig stå åben).
  // Vælgerens værdi sættes også, så et andet tegnet kort for samme udgave viser det samme valg.
  function paintTile(li, tile) {
    var s = tileView(tile), v = s.v, add = li.querySelector('.mtwc-add'), face = li.querySelector('.mtwc-rprice');
    var buy = li.querySelector('.mtwc-buy'), sel = li.querySelector('[data-standsel]');
    li.classList.toggle('mtwc-result--outside', s.outside);
    li.setAttribute('data-pick', v ? String(v.id) : '');
    [add, li.querySelector('.mtwc-card')].forEach(function (el) {
      if (!el) return;
      if (v) el.setAttribute('data-pickadd', ''); else el.removeAttribute('data-pickadd');
    });
    if (add) { add.disabled = !v; add.title = s.addLbl; add.setAttribute('aria-label', s.addLbl); }
    if (face) face.innerHTML = faceHTML(v);
    if (buy) { if (v) buy.title = variantLabel(v); else buy.removeAttribute('title'); }
    if (sel && v) sel.value = String(v.id);
  }
  // Lægger netop den variant i, kortet viser som valgt (data-pick), slået op i de friske data: aldrig DOM-tekst, aldrig en
  // anden udgave, og kun uden for stand-grænsen, når kunden selv har valgt standen i kortets vælger (choiceOf).
  // Viser kortet intet valg, lægges intet i. Passer det viste ikke længere med data, lægges heller intet i: kunden får besked
  // (solgt, når den viste variant ikke er på lager; ellers at kortet er opdateret), og listen tegnes igen.
  // Svar: 'lagt' | 'intet' | 'afvist'.
  function addShown(li) {
    var shown = li.getAttribute('data-pick'), tile = tileOf(li.getAttribute('data-handle'), li.getAttribute('data-tile'));
    if (!shown) return 'intet';
    var v = tile ? choiceOf(tile, K.standSummary(tile)) : null;
    if (!v || String(v.id) !== shown) {
      var was = tile ? K.variantById(tile, shown) : null;
      toast(was && was.available ? MOVED_TEXT : SOLD_TEXT);
      redraw();
      return 'afvist';
    }
    addVariant(tile, v);
    return 'lagt';
  }
  // Kortet i afklar-køen (liste-import): valg-linje og stand-chips; et tryk på en chip lægger linjens antal i (se clarifyClick).
  function candTileHTML(tile) {
    var v = K.pick(tile, limit), sum = K.standSummary(tile), outside = !v && sum.length > 0;
    var h = esc(tile.handle), nb = inBinder(tile.handle, tile.key);
    var media = tile.image ? cardImg(tile.image, '') : '<span class="mtwc-ph">🃏</span>';
    var badges = (tile.edLabel ? edBadge(tile.edLabel) : '') +
      (tile.langLabel ? '<span class="mtwc-badge lang">' + esc(tile.langLabel) + '</span>' : '') +
      (tile.available ? '' : '<span class="mtwc-badge so">Udsolgt</span>');
    // Valg-linjen viser netop den variant, et tryk på kortet eller "+" lægger i.
    var line, lineCls = '', addLbl;
    if (v) {
      var a = K.abbr(v);
      line = (a ? '<b title="' + esc(v.cond) + '">' + esc(a) + '</b> · ' : '') + fmtKr(v.price);
      addLbl = 'Læg i binder: ' + variantLabel(v);
    } else if (outside) {
      line = 'Kun i ' + (sum.map(function (s) { return esc(K.abbr(s)); }).filter(Boolean).join(', ') || 'andre stande');
      addLbl = 'Ikke i din stand-grænse. Vælg en stand under kortet.';
    } else {
      line = 'Udsolgt'; lineCls = ' mtwc-rprice--so'; addLbl = 'Udsolgt';
    }
    var pickAttr = v ? ' data-pickadd' : '';
    var chips = sum.length ? sum.map(function (s) {
      var sa = K.abbr(s), lbl = esc('Læg i binder: ' + variantLabel(s));
      return '<button type="button" class="mtwc-condchip' + (v && s.id === v.id ? ' mtwc-on' : '') + '" data-variant="' + esc(String(s.id)) + '" title="' + lbl + '" aria-label="' + lbl + '">' +
        (sa ? esc(sa) + ' ' : '') + '<span class="p">' + fmtNum(s.price) + '</span></button>';
    }).join('') : '<span class="mtwc-soldout-lbl">Udsolgt</span>';
    return '<li class="mtwc-result' + (outside ? ' mtwc-result--outside' : '') + '" data-handle="' + h + '" data-tile="' + esc(tile.key) + '">' +
      (nb ? '<span class="mtwc-inb">×' + nb + '</span>' : '') +
      '<button type="button" class="mtwc-add"' + (v ? pickAttr : ' disabled') + ' title="' + esc(addLbl) + '" aria-label="' + esc(addLbl) + '">+</button>' +
      '<div class="mtwc-card"' + pickAttr + '>' + (badges ? '<span class="mtwc-badges">' + badges + '</span>' : '') + media + cardNoHTML(tile) + '</div>' +
      '<div class="mtwc-rname">' + esc(tile.title) + '</div>' +
      '<div class="mtwc-rprice mtwc-pickline' + lineCls + '">' + line + '</div>' +
      '<div class="mtwc-conds" data-conds>' + chips + '</div>' +
      '</li>';
  }
  // Har et korts stand-vælger fokus (den kan stå åben), tegnes der ikke: så ville vælgeren forsvinde under kunden.
  // Tegningen venter i waiting, til valget er truffet ('change') eller fokus har forladt vælgeren ('focusout'). now: tegn alligevel.
  function renderResults(prods, term, now) {
    var host = $('[data-mtwc-results]'), hint = $('[data-mtwc-searchhint]'), at = document.activeElement;
    if (!now && at && host.contains(at) && at.hasAttribute('data-standsel')) { waiting = { prods: prods, term: term }; return; }
    waiting = null;
    hint.hidden = true;
    drawn = prods;
    if (!prods.length) { host.innerHTML = '<li class="mtwc-loading">Ingen enkeltkort matcher “' + esc(term) + '”.</li>'; paintArrange(null); return; }
    var all = [];
    // Tegn altid fra den friske cache, så kortet viser det samme, som et tryk slår op.
    // En udsolgt udgave tegnes kun, når den er den almindelige, eller når hele kortet er udsolgt (da kun den første).
    prods.forEach(function (p) {
      var ts = K.tiles(products[p.handle] || p);
      var shown = ts.filter(function (tile) { return tile.available || (tile.plain && !onlyStock); });
      if (!shown.length && !onlyStock) shown = ts.slice(0, 1);
      all = all.concat(shown);
    });
    // Sortering og filtre (kernen) på den hentede liste, uden nyt kald. Et filter, listen ikke har, nulstilles.
    // Uden pillen (forsiden) er der ingen række at vælge i: listen står, som den kom.
    var fac = K.facets(all), on = !!view.pre, sort = K.sortFor(on ? arr.sort : '', showNumbers);
    if (fac.rarities.indexOf(arr.rar) < 0) arr.rar = '';
    if (fac.eds.indexOf(arr.ed) < 0) arr.ed = '';
    var list = K.arrange(all, { sort: sort, rarity: on ? arr.rar : '', ed: on ? arr.ed : '' }, priceShown);
    host.innerHTML = list.length || !all.length ? list.map(function (tile, n) { return tileHTML(tile, n); }).join('') : '<li class="mtwc-loading">Ingen kort passer til de valgte filtre.</li>';
    if (view.pre) setView(view.pre, view.name, list.length);
    paintArrange(all.length ? fac : null, sort);
  }
  // Prisen på det, kortet viser som valgt (null uden valg). Bruges af sorteringen efter pris.
  function priceShown(tile) { var v = choiceOf(tile, K.standSummary(tile)); return v ? v.price : null; }
  // Rækken under pillen: sortering, sjældenhed og udgave (rigtige <select>, som Stand). Vises kun, når pillen står over en liste
  // med kort (fac null skjuler den). Valgmulighederne skrives kun om, når de ændres: en åben vælger på telefonen må ikke lukke
  // under kunden, når resten af listen kommer. En vælger med under to valg at filtrere på vises ikke.
  var arrHTML = Object.create(null);
  function paintArrange(fac, sort) {
    var row = $('[data-mtwc-arrange]'), pill = $('[data-mtwc-view]');
    if (!row) return;
    row.hidden = !fac || !pill || pill.hidden;
    if (row.hidden) return;
    function fill(key, list, value) {
      var sel = $('[data-mtwc-arr="' + key + '"]'), html = list.map(function (o) { return '<option value="' + esc(o.key) + '">' + esc(o.label) + '</option>'; }).join('');
      if (arrHTML[key] !== html) { sel.innerHTML = html; arrHTML[key] = html; }
      sel.value = value;
    }
    var alle = [{ key: '', label: 'Alle' }];
    fill('sort', K.sorts(showNumbers), sort);
    fill('rar', alle.concat(fac.rarities.map(function (r) { return { key: r, label: r }; })), arr.rar);
    fill('ed', alle.concat(K.ED_GROUPS.filter(function (g) { return fac.eds.indexOf(g.key) > -1; })), arr.ed);
    $('[data-mtwc-arrf="rar"]').hidden = fac.rarities.length < 2;
    $('[data-mtwc-arrf="ed"]').hidden = fac.eds.length < 2;
    paintAddAll();
  }

  /* ---------- "Læg alle N i binderen" (rækken under pillen) ---------- */
  // De viste kort i den viste rækkefølge som [{ tile, v }], slået op i de friske data. v er det, kortet viser som valgt (data-pick,
  // som addShown); passer det ikke længere med data, er v null, og kortet kommer ikke med. Hvad der kommer med, afgør kernen (K.bulkRows).
  // Et kort, broen har skjult med sit binder-filter (display: none på kortet selv), er ikke vist og kommer ikke med.
  function shownRows() {
    var rows = [];
    $$('.mtwc-result', $('[data-mtwc-results]')).forEach(function (li) {
      if (window.getComputedStyle(li).display === 'none') return;
      var tile = tileOf(li.getAttribute('data-handle'), li.getAttribute('data-tile')), pick = li.getAttribute('data-pick'), v = null;
      if (!tile) return;
      if (pick) { v = choiceOf(tile, K.standSummary(tile)); if (v && String(v.id) !== pick) v = null; }
      rows.push({ tile: tile, v: v });
    });
    return rows;
  }
  // Broens "kun mangler"-filter skjuler kort efter tegningen (klassen mtwsb-hide, lidt forsinket). Så tælles tallet i pillen og
  // "Læg alle N" igen. Kun et skift af den klasse på selve kortet tæller: motorens egne klasseskift i listen sætter intet i gang,
  // og optællingen rører ingen klasser i listen, så den kan ikke kalde sig selv.
  var hideT = null;
  function hideFlip(m) {
    var el = m.target;
    return !!el.classList && el.classList.contains('mtwc-result') && /(^|\s)mtwsb-hide(\s|$)/.test(m.oldValue || '') !== el.classList.contains('mtwsb-hide');
  }
  function recount() {
    var cnt = $('[data-mtwc-viewn]');
    if (view.pre && cnt && !cnt.hidden) {
      var n = $$('.mtwc-result', $('[data-mtwc-results]')).filter(function (li) { return window.getComputedStyle(li).display !== 'none'; }).length;
      cnt.textContent = '· ' + n + ' kort';
    }
    paintAddAll();
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (ms) {
      if (!ms.some(hideFlip)) return;
      clearTimeout(hideT);
      hideT = setTimeout(recount, 50);
    }).observe($('[data-mtwc-results]'), { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }
  // Knappen vises kun sammen med rækken og kun, når mindst 2 kort kan lægges i. Følger binderen og kortenes valg (se render og 'change').
  function paintAddAll() {
    var btn = $('[data-mtwc-addall]'), row = $('[data-mtwc-arrange]');
    if (!btn) return;
    var n = row && !row.hidden ? K.bulkRows(shownRows(), items).length : 0;
    btn.hidden = n < 2;
    if (n >= 2) btn.textContent = 'Læg alle ' + n + ' i binderen';
  }
  // Ét tryk: hvert kort med antal 1 i den viste rækkefølge, som ét fortryd-trin (én commit). Er der ikke plads til alle, kommer de første med.
  // Ingen mtwc:added pr. kort: broen ville tilbyde stempling for hvert eneste.
  // Beskeden med Fortryd bliver stående, til den næste besked erstatter den. Ændres binderen ellers (+/−, fjern, anden fane),
  // skjules den (dropBulkToast i commit og sync): Fortryd ville ellers tage den ændring i stedet for hele "Læg alle".
  var UNDO_BTN = ' <button type="button" class="mtwc-toast-act" data-mtwc-undo="alle">Fortryd</button>';
  function dropBulkToast() {
    var t = $('[data-mtwc-toast]');
    if (!t || !t.querySelector('[data-mtwc-undo="alle"]')) return;
    clearTimeout(toastT); t.classList.remove('show');
    toastT = setTimeout(function () { t.innerHTML = ''; }, 300); // efter udtoningen: knappen kan heller ikke nås med tastaturet
  }
  function addAll() {
    if (busy) return;
    var rows = shownRows(), want = 0, r = null;
    commit(function (base) {
      var pick = K.bulkRows(rows, base);
      want = pick.length;
      r = K.addRows(base, pick);
      if (r.added) cur = Math.floor((r.items.length - r.added) / 9); // vis siden med det første nye kort
      return r.added ? r.items : base;
    });
    if (!r || !want) return;
    if (!r.added) { toast(FULL_TEXT); return; }
    toast((r.added < want ? r.added + ' af ' + want + ' kort kom med; binderen kan højst rumme ' + K.CAP : r.added + ' kort lagt i binderen') + UNDO_BTN, Infinity);
  }
  // Tegner den viste liste igen (ny stand-grænse eller friske data) uden netværkskald. Venter en tegning, er det den, der tegnes.
  function redraw(now) {
    if (waiting) renderResults(waiting.prods, waiting.term, now);
    else if (drawn.length) renderResults(drawn, '', now);
  }

  /* ---------- binder render ---------- */
  // Lomme i på den viste side er items[cur * 9 + i]. Alt fra kataloget og fra det gemte escapes.
  function pocketHTML(item, isNext) {
    if (!item) return '<div class="mtwc-pocket mtwc-empty' + (isNext ? ' mtwc-next' : '') + '"></div>';
    var d = K.describe(item), a = K.abbr(item.cond), ed = K.edLabel(item.ed), lang = K.langLabel(item.lang), qty = '';
    var price = fmtKr(item.price * item.qty);
    if (item.max > 1 || item.qty > 1) {
      qty = '<span class="mtwc-qty"><button type="button" data-qty="-1" aria-label="Én færre, nu ' + item.qty + '">−</button><b>' + item.qty + '</b>' +
        // Ved loftet er plus ikke "disabled" (så ville fokus hoppe til minus): den er markeret og ignorerer trykket.
        '<button type="button" data-qty="1" aria-label="Én mere, nu ' + item.qty + '"' + (item.qty >= item.max ? ' class="mtwc-max" aria-disabled="true"' : '') + '>+</button></span>';
    }
    // tabindex -1: lommen kan få fokus, når kortet på pladsen er fjernet (se focusPocket).
    return '<div class="mtwc-pocket mtwc-filled' + (item.flag ? ' mtwc-flagged' : '') + '" data-variant-id="' + esc(String(item.variantId)) + '" role="group" tabindex="-1" aria-label="' + esc(item.title + (d ? ', ' + d : '')) + '">' +
      (item.flag ? '<span class="mtwc-flag">' + esc(item.flag) + '</span>' : '') +
      // Udgave og sprog som mærkat øverst (som på resultatkortet), så tekstlinjen kun skal rumme stand og pris.
      (ed || lang ? '<span class="mtwc-badges mtwc-pbadges">' + (ed ? edBadge(ed) : '') + (lang ? '<span class="mtwc-badge lang">' + esc(lang) + '</span>' : '') + '</span>' : '') +
      '<button type="button" class="mtwc-rm" data-rm aria-label="Fjern kortet">✕</button>' +
      '<div class="mtwc-card">' + (item.img ? cardImg(item.img, item.title) : '<span class="mtwc-ph">🃏</span>') + '</div>' +
      qty +
      // Tekstlinjen: standens forkortelse og prisen (antallet står i tælleren). Den fulde beskrivelse står i lommens aria-label.
      '<span class="mtwc-cond mtwc-cond--short">' + (a ? '<span class="mtwc-cond-d" title="' + esc(item.cond) + '">' + esc(a) + '</span> ' : '') + price + '</span></div>';
  }
  function renderChrome() {
    var pc = pageCount(), n = K.count(items), dots = '';
    $('[data-mtwc-pagelabel]').textContent = 'Side ' + (cur + 1) + ' / ' + pc;
    $('[data-mtwc-prev]').disabled = cur === 0;
    $('[data-mtwc-next]').disabled = cur >= pc - 1;
    // Over 12 sider: kun "Side N / M", ingen prikker.
    if (pc <= 12) for (var i = 0; i < pc; i++) dots += '<button type="button" class="mtwc-pdot' + (i === cur ? ' on' : '') + (items.length > i * 9 ? ' has' : '') + '" data-page="' + i + '" aria-label="Side ' + (i + 1) + '"></button>';
    $('[data-mtwc-dots]').innerHTML = dots;
    $('[data-mtwc-dots]').hidden = !dots;
    $('[data-mtwc-bhint]').textContent = n ? n + ' kort i binderen' : 'Klik et kort for at lægge det i';
    $('[data-mtwc-clearall]').disabled = n === 0;
    $('[data-mtwc-clearpage]').disabled = items.length <= cur * 9;
  }
  // Tegner de 9 lommer på den viste side. Næste ledige lomme fremhæves på sidste side, så længe der er plads i binderen.
  function renderBinder() {
    var html = '', base = cur * 9, room = cur === pageCount() - 1 && K.count(items) < K.CAP;
    for (var i = 0; i < 9; i++) html += pocketHTML(items[base + i], room && base + i === items.length);
    $('[data-mtwc-page]').innerHTML = html;
    renderChrome();
  }
  function renderTotals() {
    var n = K.count(items), t = K.total(items);
    $('[data-mtwc-tabcount]').textContent = n;
    $('[data-mtwc-addcart]').disabled = n === 0 || busy;
    $('[data-mtwc-cta-full]').textContent = n === 0 ? 'Tilføj kort for at starte' : ('Læg ' + n + ' kort i kurv · ' + fmtKr(t));
    $('[data-mtwc-cta-short]').textContent = n === 0 ? 'Kurv' : (n + ' kort · ' + fmtKr(t));
    // Mobilens bundbjælke (kun under 900 px, se CSS): "12 kort · 340 kr" og Læg i kurv, når binderen ikke er tom.
    // mtwc-docked på roden løfter beskeden over bjælken.
    var dock = $('[data-mtwc-dock]');
    if (dock) {
      dock.hidden = n === 0;
      $('[data-mtwc-docktxt]').textContent = n + ' kort · ' + fmtKr(t);
      $('[data-mtwc-docksum]').setAttribute('aria-label', 'Se binderen: ' + n + ' kort, ' + fmtKr(t));
      $('[data-mtwc-dockcart]').disabled = n === 0 || busy;
      root.classList.toggle('mtwc-docked', n > 0);
    }
  }
  // Binder-ændringer må IKKE genrendere resultat-gridet (img-flimmer + scroll-reset).
  // Opdatér kun ×N-badges på eksisterende resultat-kort i stedet.
  function updateResultBadges() {
    $$('.mtwc-result').forEach(function (el) {
      var n = inBinder(el.getAttribute('data-handle'), el.getAttribute('data-tile'));
      var badge = el.querySelector('.mtwc-inb');
      if (n) {
        if (badge) badge.textContent = '×' + n;
        else { var s = document.createElement('span'); s.className = 'mtwc-inb'; s.textContent = '×' + n; el.insertBefore(s, el.firstChild); }
      } else if (badge) { badge.remove(); }
    });
  }
  function render() { renderBinder(); renderTotals(); updateResultBadges(); paintAddAll(); }
  function goToPage(i) { cur = Math.max(0, Math.min(pageCount() - 1, i)); renderBinder(); }
  // Lommerne tegnes forfra ved hver ændring: sæt fokus tilbage på antal-knappen, så tastaturet kan blive ved.
  function focusQty(id, up) {
    $$('[data-variant-id]', $('[data-mtwc-page]')).forEach(function (p) {
      if (p.getAttribute('data-variant-id') !== id) return;
      var b = p.querySelector('[data-qty="' + (up ? '1' : '-1') + '"]');
      if (b) b.focus();
    });
  }
  // Kortet på plads i (i items) er fjernet: fokus på lommen, der nu står der (ellers den sidste lomme), eller på binder-siden, når den er tom.
  function focusPocket(i) {
    var page = $('[data-mtwc-page]'), it = items[Math.min(i, items.length - 1)], el = null;
    if (it) $$('[data-variant-id]', page).forEach(function (p) { if (p.getAttribute('data-variant-id') === String(it.variantId)) el = p; });
    (el || page).focus();
  }
  // Første side, hvis indhold er forskelligt i de to lister (uændrede kort er samme objekt i begge).
  function firstChangedPage(a, b) {
    var n = Math.max(a.length, b.length), i = 0;
    while (i < n && a[i] === b[i]) i++;
    return Math.floor(i / 9);
  }

  /* ---------- liste-import og afklaring ---------- */
  // En linje fra listen må kun selv lægge den almindelige udgave (Normal, engelsk) inden for stand-grænsen i.
  // Alt andet (flere mulige kort, kun en anden udgave, kun uden for grænsen) går til afklaring, hvor kunden selv
  // trykker på udgavens kort eller en stand-chip. Begge veje ender i addVariant.
  var clarifyRows = [], clSeq = 0, clQuiet = 0; // clQuiet: tidspunkt, før hvilket tryk i afklaringen ignoreres (dobbelt-tryk)
  // seneste kørsel: { running, total, at, added, missed, failed, sold, notes, full, skipped, stopped, unread, cut }
  //   total/at: linjer i kørslen og den linje, der slås op nu. missed: uden match. failed: kunne ikke slås op (butikken svarede ikke).
  //   full/skipped: binderen blev fuld, og så mange linjer blev ikke slået op. stopped/unread: det samme, når butikken ikke svarer.
  //   cut: listen var længere end PASTE_MAX linjer; resten er ikke taget med.
  var paste = null;
  var PASTE_MAX = 250, PASTE_STOP = 3;          // højst så mange linjer pr. kørsel; stop efter så mange fejlede opslag i træk
  // Antal læses kun som "3 Navn", "3x Navn" eller "3 x Navn": et tal på 1-2 cifre fra 1 til 20. Over 4 sættes ned til 4
  // (asked husker det skrevne tal, så resultatet kan sige "4 af 5"). Alt andet er en del af navnet ("151 Mew ex").
  function parseLine(line) {
    var s = K.clean(line); if (!s) return null;
    var qty = 1, asked = 1, m = s.match(/^(\d{1,2})\s*[xX]?\s+(.+)$/), n = m ? parseInt(m[1], 10) : 0;
    if (n >= 1 && n <= 20) { asked = n; qty = Math.min(n, K.MAX_QTY); s = m[2].trim(); }
    return { name: s, qty: qty, asked: asked };
  }
  function buildSuggest(term) {
    return ROOTURL + 'search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
  }
  // Mulige kort for et navn: [{ handle, title, image }]. Afvises, når der ikke kan søges (linjen tælles da som "kunne ikke slås op").
  function suggestOnce(term) {
    return fetch(buildSuggest(term)).then(function (r) { if (!r.ok) throw new Error('suggest'); return r.json(); })
      .then(function (d) {
        return (((d.resources || {}).results || {}).products || []).filter(function (p) { return p && typeof p.handle === 'string' && isSingle(p.type); })
          .map(function (p) { return { handle: p.handle, title: K.clean(p.title), image: (p.featured_image && p.featured_image.url) || p.image || null, p: null }; });
      });
  }
  // Udgave-mærkat på ét billede: én kort linje. "Reverse Masterball Holo" vises som "Reverse Masterball"
  // (det afsluttende "Holo" er underforstået, når der står mere end to ord); det fulde navn står i title.
  function edBadge(label) {
    var w = String(label).split(' ');
    var kort = (w.length >= 3 && /^holo$/i.test(w[w.length - 1])) ? w.slice(0, -1).join(' ') : label;
    return '<span class="mtwc-badge rh" title="' + esc(label) + '">' + esc(kort) + '</span>';
  }
  function tileName(t) { return [t.edLabel, t.langLabel].filter(Boolean).join(' '); }
  // Lægger op til qty af netop den variant i (stille). Svar: { n, why, full }; why er tom, når alle kom i.
  // run = { silent: true } deles af alle kort i én kørsel: kun det første kort lægger et fortryd-trin, så Fortryd tager hele kørslen.
  function addN(tile, v, qty, run) {
    var n = 0;
    while (n < qty && addVariant(tile, v, run)) { n++; run.noUndo = true; }
    if (n === qty) return { n: n, why: '', full: false };
    var full = K.count(items) >= K.CAP;
    return { n: n, full: full, why: busy ? 'Binderen er låst, mens den lægges i kurven' : full ? 'Binderen er fuld' : maxText(v.qty) };
  }
  // Ét frisk opslag, og den almindelige udgave lægges i op til qty gange. Der vælges aldrig en anden udgave og aldrig
  // uden for stand-grænsen. Svar: { n, why, full, p, state }, hvor p er det friske produkt og state er
  //   'lagt'    : den almindelige udgave kunne vælges (n siger, hvor mange der kom i; why hvorfor ikke alle)
  //   'vaelg'   : på lager, men kun i en anden udgave eller uden for stand-grænsen: kunden må selv vælge
  //   'udsolgt' : intet på lager
  //   'hent'    : kortet kunne ikke hentes (p er null)
  function bulkAddN(handle, qty, run) {
    return fetchFresh([handle]).then(function (fresh) {
      var p = fresh[handle];
      // Står kortet i resultatlisten, følger det de friske data, så listen viser det, et tryk lægger i.
      if (p && drawn.some(function (x) { return x.handle === handle; })) redraw();
      if (!p) return { n: 0, why: 'Kunne ikke hente kortet. Prøv igen.', full: false, p: null, state: 'hent' };
      var ts = K.tiles(p), t0 = ts[0], v = t0 && t0.plain ? K.pick(t0, limit) : null;
      if (v) { var res = addN(t0, v, qty, run); res.p = p; res.state = 'lagt'; return res; }
      var stock = ts.filter(function (t) { return t.available; });
      if (!stock.length) return { n: 0, why: 'Udsolgt', full: false, p: p, state: 'udsolgt' };
      return { n: 0, why: (stock[0].plain ? 'Ikke i din stand-grænse' : 'Findes kun som ' + stock.map(tileName).join(', ')) + '. Vælg selv herunder.', full: false, p: p, state: 'vaelg' };
    });
  }
  function runPaste() {
    var all = $('[data-mtwc-pastearea]').value.split('\n').map(parseLine).filter(Boolean), lines = all.slice(0, PASTE_MAX);
    if (!lines.length) return;
    var btn = $('[data-mtwc-pasterun]');
    var st = paste = { running: true, total: lines.length, at: 0, added: 0, missed: 0, failed: 0, sold: 0, notes: [], full: false, skipped: 0, stopped: false, unread: 0, cut: all.length > lines.length };
    var run = { silent: true }; // hele kørslen er ét fortryd-trin (se addN)
    clarifyRows = [];
    btn.disabled = true;
    renderClarify();
    toast(esc(pasteStatus()));
    // Linjen nævnes, som kunden skrev den (med det skrevne antal).
    function note(ln, text) { st.notes.push({ q: (ln.asked > 1 ? ln.asked + ' ' : '') + ln.name, text: text }); }
    // Skrev kunden mere end 4, siges det på linjen, når kortet er fundet (ikke ved uden match eller udsolgt).
    function capped(ln) { if (ln.asked > ln.qty) note(ln, ln.qty + ' af ' + ln.asked + ' (højst ' + K.MAX_QTY + ' af samme kort)'); }
    function ask(ln, why, cands) { clarifyRows.push({ id: ++clSeq, q: ln.name, qty: ln.qty, why: why, busy: false, cands: cands }); }
    // Afvises, når linjen ikke kunne slås op: søgningen svarede ikke, eller kortet kunne ikke hentes.
    function one(ln) {
      return suggestOnce(ln.name).then(function (prods) {
        if (!prods.length) { st.missed++; note(ln, 'Uden match'); return; }
        var q = ln.name.toLowerCase();
        var exact = prods.filter(function (c) { return c.title.toLowerCase() === q; });
        var hit = exact.length === 1 ? exact[0] : prods.length === 1 ? prods[0] : null;
        if (!hit) { capped(ln); ask(ln, 'Flere kort matcher. Vælg det rigtige.', prods.slice(0, 5)); return; }
        return bulkAddN(hit.handle, ln.qty, run).then(function (res) {
          st.added += res.n;
          if (res.full) st.full = true;
          if (res.state === 'hent') throw new Error('opslag');
          if (res.state === 'udsolgt') { st.sold++; note(ln, 'Udsolgt'); return; }
          capped(ln);
          // Fundet, men den almindelige udgave kan ikke lægges i af sig selv: kunden vælger selv.
          if (res.state === 'vaelg') { hit.p = res.p; ask(ln, res.why, [hit]); }
          else if (res.n < ln.qty) note(ln, res.n + ' af ' + ln.qty + ' lagt i. ' + res.why + '.');
        });
      });
    }
    var chain = Promise.resolve(), left = lines.length, strikes = 0;
    lines.forEach(function (ln) {
      chain = chain.then(function () {
        if (st.stopped) return; // butikken svarer ikke: resten af listen slås ikke op (talt i st.unread)
        // Fuld binder: resten af listen slås ikke op.
        if (st.full || K.count(items) >= K.CAP) { st.full = true; st.skipped = left; return; }
        left--;
        st.at++;
        $('[data-mtwc-pasteprogress]').textContent = pasteStatus(); // fremdrift: "Matcher 37 af 120 …" (læses ikke op, se renderClarify)
        // Kan linjen ikke slås op (netværk, 429/430/5xx, uventet svar), tælles den for sig, aldrig som uden match.
        // Efter PASTE_STOP sådanne linjer i træk stopper kørslen: butikken skal ikke spørges 250 gange, når den siger nej.
        return one(ln).then(function () { strikes = 0; }, function () {
          st.failed++; note(ln, 'Kunne ikke slås op');
          if (++strikes >= PASTE_STOP) { st.stopped = true; st.unread = left; }
        });
      });
    });
    function done() {
      btn.disabled = false; // altid, også efter en uventet fejl
      st.running = false;
      cur = pageCount() - 1;
      render();
      renderClarify();
      toast(esc(pasteStatus()));
    }
    chain.then(done, done);
  }
  // Fremdrift under kørslen, og bagefter den blivende resultatlinje for seneste kørsel. "Til afklaring" følger køen,
  // "Lagt i" tæller også valg i afklaringen.
  function pasteStatus() {
    if (paste.running) return 'Matcher ' + Math.max(1, paste.at) + ' af ' + paste.total + ' …';
    var t = 'Lagt i: ' + paste.added + ' · Til afklaring: ' + clarifyRows.length + ' · Uden match: ' + paste.missed;
    if (paste.failed) t += ' · Kunne ikke slås op: ' + paste.failed;
    if (paste.sold) t += ' · Udsolgt: ' + paste.sold;
    if (paste.full) t += ' · Binderen er fuld (' + K.CAP + ' kort)' + (paste.skipped ? ', så ' + paste.skipped + (paste.skipped === 1 ? ' linje' : ' linjer') + ' blev ikke slået op' : '');
    if (paste.stopped || paste.cut) t += '.';
    if (paste.stopped) t += ' Butikken svarer ikke lige nu.' + (paste.unread ? ' ' + paste.unread + (paste.unread === 1 ? ' linje' : ' linjer') + ' blev ikke slået op.' : '') + ' Prøv igen om lidt.';
    if (paste.cut) t += ' Kun de første ' + PASTE_MAX + ' linjer er taget med.';
    return t;
  }
  // Én kandidat i en afklar-række. Er kortet hentet (c.p), vises ét kort pr. udgave på lager med stand-chips
  // (candTileHTML); ellers billede og titel i en rigtig knap (kan nås med Tab), og et tryk henter kortet.
  // Et hentet kort tegnes fra den friske cache (som resultatlisten), så en stand, der er solgt imens, ikke står der.
  function candHTML(c) {
    var p = c.p ? products[c.handle] || c.p : null, ts = p ? K.tiles(p) : [], stock = ts.filter(function (t) { return t.available; });
    if (p && ts.length) return (stock.length ? stock : ts.slice(0, 1)).map(candTileHTML).join('');
    var inner = '<span class="mtwc-card">' + (c.image ? '<img src="' + esc(img(c.image, 360)) + '" alt="" decoding="async">' : '<span class="mtwc-ph">🃏</span>') + '</span>' +
      '<span class="nm">' + esc(c.title) + (c.p ? ' · Udsolgt' : '') + '</span>';
    return '<li class="mtwc-cl-cand' + (c.p ? ' mtwc-cl-gone' : '') + '">' +
      (c.p ? inner : '<button type="button" class="mtwc-cl-pick" data-clpick="' + esc(c.handle) + '">' + inner + '</button>') + '</li>';
  }
  function renderClarify() {
    var wrap = $('[data-mtwc-clarify]'), list = $('[data-mtwc-clarifylist]'), status = $('[data-mtwc-pastestatus]'), notes = $('[data-mtwc-pastenotes]');
    var prog = $('[data-mtwc-pasteprogress]'), res = paste && !paste.running ? pasteStatus() : '';
    wrap.hidden = !paste;
    if (!paste) { list.innerHTML = ''; return; }
    // Fremdriften skrives i et element, der ikke læses op. Kun slutresultatet står i resultatlinjen (role="status"),
    // sammen med sætningen om, hvilken stand liste-import vælger.
    prog.hidden = !paste.running;
    prog.textContent = paste.running ? pasteStatus() : '';
    status.textContent = res ? res + (res.slice(-1) === '.' ? ' ' : '. ') + pickText() : '';
    notes.innerHTML = paste.notes.map(function (n) { return '<li>“<b>' + esc(n.q) + '</b>”: ' + esc(n.text) + '</li>'; }).join('');
    notes.hidden = !paste.notes.length;
    $('[data-mtwc-clarifyhead]').hidden = !clarifyRows.length;
    $('[data-mtwc-clarifycount]').textContent = clarifyRows.length + ' tilbage';
    list.innerHTML = clarifyRows.map(function (row) {
      return '<div class="mtwc-cl-row" data-clrow="' + row.id + '">' +
        '<div class="mtwc-cl-q">“<b>' + esc(row.q) + '</b>” · ' + row.qty + ' stk</div>' +
        '<div class="mtwc-cl-why" tabindex="-1">' + esc(row.why) + '</div>' +
        '<ul class="mtwc-cl-cands">' + row.cands.map(candHTML).join('') + '</ul>' +
        '<div class="mtwc-cl-actions"><button type="button" class="mtwc-cl-skip" data-clskip>Spring over</button></div></div>';
    }).join('');
  }
  // Rækkerne tegnes forfra efter hvert valg, så fokus sættes igen: på rækkens årsag (ellers den første rækkes, ellers resultatlinjen).
  // Altid på en tekst, aldrig på en knap: holdes Enter nede, må den ikke komme til at lægge et kort i eller starte kørslen igen.
  function focusClarify(id) {
    var list = $('[data-mtwc-clarifylist]'), row = list.querySelector('[data-clrow="' + id + '"]');
    var el = (row || list).querySelector('.mtwc-cl-why') || $('[data-mtwc-pastestatus]');
    if (el) el.focus();
  }
  // Tryk i en afklar-række. Rækken findes på sit id (ikke sin plads), så et dobbelt-tryk aldrig rammer naboen.
  function clarifyClick(t, rowEl) {
    var row = null, id = rowEl.getAttribute('data-clrow');
    clarifyRows.forEach(function (r) { if (String(r.id) === id) row = r; });
    if (!row || row.busy || Date.now() < clQuiet) return;
    function drop() { var i = clarifyRows.indexOf(row); if (i > -1) clarifyRows.splice(i, 1); clQuiet = Date.now() + 400; }
    function redrawRows() { renderClarify(); focusClarify(row.id); }
    // Rækken forsvinder kun, når noget faktisk blev lagt i; ellers bliver den stående med årsagen.
    function settle(res) {
      if (res.n > 0) {
        drop();
        paste.added += res.n;
        cur = pageCount() - 1;
        render();
        toast('Tilføjet' + (res.n < row.qty ? ': ' + res.n + ' af ' + row.qty + '. ' + esc(res.why) : ''));
      } else { row.why = res.why; toast(esc(res.why)); }
      redrawRows();
    }
    if (t.closest('[data-clskip]')) { drop(); redrawRows(); return; }
    // Udgavens kort eller en stand-chip: netop det valg lægges i (op til linjens antal).
    var li = t.closest('.mtwc-result'), chip = t.closest('[data-variant]');
    if (li && (chip || t.closest('[data-pickadd]'))) {
      var tile = tileOf(li.getAttribute('data-handle'), li.getAttribute('data-tile'));
      var v = !tile ? null : chip ? K.variantById(tile, chip.getAttribute('data-variant')) : K.pick(tile, limit);
      if (v && v.available) settle(addN(tile, v, row.qty, { silent: true }));
      else if (chip) { toast(SOLD_TEXT); redrawRows(); } // rækken tegnes fra de friske data: den solgte stand forsvinder
      return;
    }
    // Et kort, der endnu ikke er hentet: hent det, og læg den almindelige udgave i, hvis den er inden for stand-grænsen.
    // Ellers vises kortets udgaver med stand-chips, så kunden selv vælger.
    var pick = t.closest('[data-clpick]');
    if (!pick) return;
    var handle = pick.getAttribute('data-clpick'), cand = row.cands.filter(function (c) { return c.handle === handle; })[0];
    if (!cand) return;
    row.busy = true;
    pick.style.pointerEvents = 'none';
    bulkAddN(handle, row.qty, { silent: true }).then(function (res) {
      row.busy = false;
      if (res.p) cand.p = res.p;
      // Rækken har flere kort: sig, hvilket kort årsagen gælder.
      if (res.state === 'udsolgt') res.why = cand.title + ' er udsolgt';
      else if (res.state !== 'lagt') res.why = cand.title + ': ' + res.why;
      settle(res);
    }).then(null, function () { row.busy = false; redrawRows(); });
  }

  /* ---------- måling: hændelser og kurv-attributter ---------- */
  // Hændelser til en custom pixel eller GA4 (Shopify.analytics.publish). Findes den ikke endnu (indlæses af butikken), prøves lidt
  // senere; findes den slet ikke, sker intet. Må aldrig kaste.
  function track(name, data, tries) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') { a.publish(name, data); return; }
    } catch (e) { return; }
    if ((tries || 0) < 10) setTimeout(function () { track(name, data, (tries || 0) + 1); }, 500);
  }
  // Kurv-attributterne følger med ordren (ses i Shopify-admin og kan trækkes via Admin API). Afviser aldrig og venter højst
  // MARK_MS: et fejlet eller langsomt kald må ikke stå i vejen for købet. keepalive: kaldet gøres færdigt, selvom siden skiftes.
  var MARK_MS = 4000;
  function markCart() {
    var attrs = { 'Kort-vælgeren': 'ja' }, call;
    if (kilde) attrs['Kort-vælgeren indgang'] = kilde;
    try {
      call = fetch(ROOTURL + 'cart/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
        .then(null, function () {});
    } catch (e) { call = Promise.resolve(); }
    return Promise.race([call, new Promise(function (r) { setTimeout(r, MARK_MS); })]);
  }

  /* ---------- læg i kurv ---------- */
  // Regnearbejdet ligger i kernen (K.reconcile, K.runCart, K.settle); her er kun netværk, lås og visning.
  // Et korts qty er MÅLET i kurven: kernen lægger kun forskellen i, så et ekstra tryk aldrig lægger noget i to gange.
  var STALE_MS = 30 * 60 * 1000;
  function uniq(list) {
    var out = [], seen = Object.create(null);
    (Array.isArray(list) ? list : []).forEach(function (h) { if (typeof h === 'string' && h && !seen[h]) { seen[h] = 1; out.push(h); } });
    return out;
  }
  // Læsninger (lagerkontrol og /cart.js, ALDRIG /cart/add.js) har en tidsgrænse. run(signal) giver et løfte om det færdige svar,
  // kroppen medregnet. Efter READ_MS afvises der som ved en netværksfejl, og kaldet afbrydes, når browseren har AbortController.
  var READ_MS = 20000;
  function timed(run) {
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('tidsgrænse')); if (ctl) ctl.abort(); }, READ_MS);
      Promise.resolve().then(function () { return run(ctl ? ctl.signal : undefined); })
        .then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }
  // Friske data for hvert handle, højst 6 kald ad gangen. Svar: { handle: produkt | null }; afviser aldrig. Opdaterer products.
  // 404 (produktet er slettet) giver et tomt produkt, så kernen melder "Solgt". Netværksfejl, tidsgrænse, andre statuskoder
  // og coming soon giver null ("Kunne ikke tjekke lager"): vi gætter ikke.
  // Tidligt stop: tre kald i træk, der bliver afvist (429, 430, 5xx) eller slet ikke giver et brugbart svar (netværksfejl,
  // tidsgrænse, ulæselig krop), og resten af listen får null uden flere kald. Butikken skal ikke spørges 250 gange, når den siger nej.
  // Kald, der er undervejs, når stoppet falder, ventes der ikke på: de får også null (så en butik, der slet ikke svarer,
  // låser værktøjet i én tidsgrænse, ikke to).
  function fetchFresh(handles, onProgress) {
    var out = Object.create(null), i = 0, done = 0, LANES = 6, strikes = 0, STOP_AT = 3, stopped = false, stop;
    var halted = new Promise(function (resolve) { stop = resolve; });
    function one(h) {
      return timed(function (signal) {
        // Uden Accept-header (se fetchPage). no-store: et gemt svar er ikke en lagerkontrol.
        return fetch(ROOTURL + 'products/' + encodeURIComponent(h) + '?view=mtwjson', { cache: 'no-store', signal: signal })
          .then(function (r) {
            if (r.status === 404) return { product: { id: 0, handle: h, title: '', product_type: '', images: [], options: [], variants: [] } };
            if (r.status === 429 || r.status === 430 || r.status >= 500) throw new Error('afvist');
            return r.ok ? r.json() : null;
          });
      }).then(function (d) { strikes = 0; return d && d.product ? remember(d.product) : null; })
        .then(null, function () { if (++strikes >= STOP_AT) { stopped = true; stop(null); } return null; });
    }
    function lane() {
      if (i >= handles.length) return Promise.resolve();
      var h = handles[i++];
      return (stopped ? halted : Promise.race([one(h), halted])).then(function (p) {
        out[h] = p; done++;
        if (onProgress) { try { onProgress(done, handles.length); } catch (e) {} }
        return lane();
      });
    }
    var lanes = [];
    for (var l = 0; l < LANES && l < handles.length; l++) lanes.push(lane());
    return Promise.all(lanes).then(function () { return out; });
  }
  // Kurven som { variantId: antal } (lagt sammen på tværs af linjer). Afviser, når kurven ikke kan læses
  // (også efter tidsgrænsen): et svar, vi ikke forstår, er aldrig "tom kurv".
  function readCart() {
    return timed(function (signal) {
      return fetch(ROOTURL + 'cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' }, signal: signal })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }).then(function (c) {
      if (!c || !Array.isArray(c.items)) throw new Error('cart');
      var m = {};
      c.items.forEach(function (li) { m[li.variant_id] = (m[li.variant_id] || 0) + li.quantity; });
      return m;
    });
  }
  // Én bunke til kurven. Svar: { ok, status, message }. Ingen tidsgrænse: et afbrudt kald kan være lagt i alligevel.
  // ok er kun sand, når butikken selv siger, at linjerne er lagt i: 2xx uden omdirigering OG en krop, der er kurvens eget JSON
  // ({ items: [...] }; eller selve linjen, når der kun blev sendt én). Målt i butikken: 200 + { items: [...] } ved succes,
  // 422 + { status, message, description } ved afvisning. Et 200-svar med HTML (omdirigering til adgangskode- eller
  // kontrolside) er ikke en kurv. Alt, vi ikke kan læse som butikkens eget svar, meldes med status 0: kernen læser da kurven
  // og prøver ikke igen. 422 tæller kun som varens skyld, når kroppen er butikkens JSON.
  function postAdd(lines) {
    var UNKNOWN = { ok: false, status: 0, message: '' };
    return fetch(ROOTURL + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lines }) })
      .then(function (r) {
        return r.json().then(null, function () { return null; }).then(function (b) {
          if (r.redirected || !b || typeof b !== 'object' || Array.isArray(b)) return UNKNOWN;
          if (r.ok) {
            var landed = (Array.isArray(b.items) && b.items.length > 0) || (lines.length === 1 && (b.variant_id != null || b.id != null));
            return landed ? { ok: true, status: r.status, message: '' } : UNKNOWN;
          }
          var msg = b.description || b.message;
          return { ok: false, status: r.status, message: typeof msg === 'string' ? K.clean(msg) : '' };
        });
      });
  }
  // Knappens tekst skrives altid i de to spans (lang og kort udgave); knappens indhold erstattes aldrig.
  function setCta(full, short) { $('[data-mtwc-cta-full]').textContent = full; $('[data-mtwc-cta-short]').textContent = short || full; }
  // Et kald til kurven har ingen tidsgrænse og afbrydes aldrig (se postAdd). Er der ikke svar efter SLOW_MS, får kunden en
  // blivende besked i knappen og i beskedlinjen, så værktøjet ikke bare står låst. Kommer svaret alligevel, fortsætter kørslen,
  // og beskeden fjernes. Genindlæses siden, læser næste tryk kurven først: intet lægges i to gange.
  var SLOW_MS = 30000, SLOW_TEXT = 'Det tager længere end ventet. Genindlæs siden. Intet lægges i to gange.';
  function watched(p) {
    var late = false, t = setTimeout(function () { late = true; setCta(SLOW_TEXT, 'Genindlæs siden'); toast(SLOW_TEXT, Infinity); }, SLOW_MS);
    function done() { clearTimeout(t); if (late) $('[data-mtwc-toast]').classList.remove('show'); }
    return p.then(function (v) { done(); return v; }, function (e) { done(); throw e; });
  }
  // Låsen. Mens busy er sand, kan binderen ikke ændres (klik, Enter, liste-import, andre faner), der kan ikke trykkes igen,
  // og værktøjet kan ikke lukkes. busy sættes kun her.
  function lock(on) {
    busy = on;
    if (on) runs++;
    try {
      var app = $('[data-mtwc-app]');
      app.classList.toggle('mtwc-busy', on);
      if (on) app.setAttribute('aria-busy', 'true'); else app.removeAttribute('aria-busy');
      // Når låsen slippes: har en anden fane skrevet imens, gælder dens binder.
      if (on) renderTotals(); else { sync(); render(); }
    } catch (e) {}
  }
  // Kører fn bag låsen. Låsen slippes altid igen, også når noget uventet kaster.
  function locked(fn) {
    lock(true);
    return Promise.resolve().then(fn).then(function (v) { lock(false); return v; }, function (e) { lock(false); throw e; });
  }
  // Kun én fane ad gangen må køre kurv-forløbet: to faner, der trykker samtidig, læser samme kurv og lægger begge i.
  // exclusive(fn) kører fn (som selv tager låsen i fanen med locked) bag en lås på tværs af faner og giver fn's løfte videre.
  // Er låsen optaget, køres fn ikke, og der afvises med Error('anden-fane'). Er et tryk i denne fane allerede ved at spørge
  // om låsen, afvises med Error('optaget'). Svarer låsen slet ikke inden ASK_MS, afvises også med Error('optaget'), asking ryddes,
  // og et svar, der kommer senere, starter ingen kørsel: intet er sendt, og kunden kan trykke igen.
  //   navigator.locks (når den findes): låsen holdes, til løftet fra fn er afgjort, og slippes af browseren, hvis fanen lukkes.
  //   Ellers en tidsstemplet lejekontrakt i localStorage: gælder i 120 sek., fornyes ikke, og fjernes i både succes- og fejlvej.
  //   En ældre kontrakt (fanen bag den er væk) gælder ikke. Kan der slet ikke skrives i lageret, køres der uden lås.
  var LOCK_NAME = 'mtwc-kurv', LEASE_KEY = 'mtwc-kurv-laas', LEASE_MS = 120000;
  var OTHER_TAB = 'En anden fane lægger i kurven lige nu. Prøv igen om et øjeblik.';
  var ASK_MS = 5000;
  function exclusive(fn) {
    if (asking) return Promise.reject(new Error('optaget'));
    asking = true;
    var started = false, gaveUp = false, giveUp;
    var noAnswer = new Promise(function (resolve, reject) { giveUp = reject; }); // afvises, når låsen ikke har svaret inden ASK_MS
    var ask = setTimeout(function () { gaveUp = true; asking = false; giveUp(new Error('optaget')); }, ASK_MS);
    function go() { clearTimeout(ask); started = true; asking = false; return fn(); }
    function taken() { clearTimeout(ask); asking = false; return Promise.reject(new Error('anden-fane')); }
    function lease() {
      var now = Date.now(), mine = now + ':' + Math.random(), held = null, wrote = false;
      try { held = localStorage.getItem(LEASE_KEY); } catch (e) {}
      var t = parseInt(held, 10);
      if (held && isFinite(t) && Math.abs(now - t) < LEASE_MS) return taken();
      try { localStorage.setItem(LEASE_KEY, mine); wrote = true; } catch (e) {}
      if (!wrote) return Promise.resolve().then(go);
      function free() { try { if (localStorage.getItem(LEASE_KEY) === mine) localStorage.removeItem(LEASE_KEY); } catch (e) {} }
      // To faner kan nå at skrive næsten samtidig: vent et øjeblik, og se, hvis kontrakt der står. Kun den fane kører.
      return new Promise(function (r) { setTimeout(r, 100); }).then(function () {
        var now2 = mine;
        try { now2 = localStorage.getItem(LEASE_KEY); } catch (e) {}
        return now2 === mine ? go() : taken();
      }).then(function (v) { free(); return v; }, function (e) { free(); throw e; });
    }
    var locks = null, p;
    try { locks = navigator.locks; } catch (e) {}
    if (!locks || typeof locks.request !== 'function') return lease();
    try { p = locks.request(LOCK_NAME, { ifAvailable: true }, function (l) { if (gaveUp) return undefined; return l ? go() : taken(); }); } catch (e) { return lease(); }
    // Kan låsen slet ikke bruges her (fx SecurityError), bruges lejekontrakten. En fejl fra selve kørslen gives videre.
    return Promise.race([p, noAnswer]).then(null, function (e) {
      if (started || gaveUp || (e && e.message === 'anden-fane')) throw e;
      return lease();
    });
  }
  // Frisk kontrol og kurv-kørsel for en liste kort. Svar: { added, already, left, problems, blind, cartHad }.
  //   added: antal kort lagt i nu. already: antal kort, der lå i kurven i forvejen.
  //   left: kort, der ikke kom i (årsagen står i flag; qty er stadig det ønskede antal). problems: kernens liste ({ item, code, fra }).
  //   blind: et kald til kurven fejlede, og kurven kunne ikke læses bagefter. Så er udfaldet ukendt: kort i left kan ligge i kurven,
  //     og added er kun det, vi med sikkerhed ved. cartHad: kurven, der blev læst før kørslen, havde allerede linjer.
  // opts.fromBinder: listen er binderen; udfaldet lægges oven på den gemte binder (settleBinder), før svaret gives.
  // opts.fresh: friske produkter, når kalderen lige har hentet dem.
  // Kurven læses efter lagerkontrollen, lige før der sendes. Kan den ikke læses, sendes intet: kernen får null og markerer alle kort.
  function checkout(list, opts) {
    opts = opts || {};
    if (!list.length) return Promise.resolve({ added: 0, already: 0, left: [], problems: [], blind: false, cartHad: false });
    var blind = false;
    setCta('Tjekker lager …');
    var fresh = opts.fresh ? Promise.resolve(opts.fresh) : fetchFresh(uniq(list.map(function (it) { return it.handle; })), function (d, n) { setCta('Tjekker lager ' + d + '/' + n, 'Tjekker ' + d + '/' + n); });
    return fresh.then(function (f) {
      return readCart().then(null, function () { return null; }).then(function (cart) {
        var rec = K.reconcile(list, f, cart);
        if (rec.plan.length) setCta('Lægger i kurv …');
        return K.runCart(rec.plan, rec.baseline, {
          postAdd: function (lines) { return watched(postAdd(lines)); },
          // Kernen læser kun kurven her efter et fejlet kald. Kan den heller ikke læses, ved vi ikke, hvad der kom i.
          getCart: function () { return readCart().then(null, function (e) { blind = true; throw e; }); },
          onProgress: function (d, n) { setCta('Lægger i kurv ' + d + '/' + n); }
        }).then(function (result) {
          var s = K.settle(rec.items, result, rec.already);
          if (s.added > 0 || blind) cartChanged = true; // siden bag værktøjet viser nu en forældet kurv (se closeApp, hideOverlay)
          if (opts.fromBinder) settleBinder(list, s.items);
          var report = { added: s.added, already: K.count(rec.already), left: s.items, problems: rec.problems, blind: blind, cartHad: !!rec.baseline && Object.keys(rec.baseline).length > 0 };
          if (!s.added) return report;
          // Måling: kom der kort i kurven, får kurven sine attributter, før kunden sendes videre, og hændelsen sendes.
          var kr = 0;
          result.added.forEach(function (a) { var i = K.indexOf(rec.items, a.variantId); if (i > -1) kr += rec.items[i].price * a.quantity; });
          track('kortvaelger_lagt_i_kurv', { sted: kilde, antal: s.added, beloeb: Math.round(kr * 100) / 100 });
          return markCart().then(function () { return report; });
        });
      });
    });
  }
  // Kørslens udfald lægges oven på den binder, der står gemt NU (en anden fane kan have ændret den imens):
  // kort fra kørslen, der er i kurven, fjernes; kort, der ikke kom i, får kørslens udgave (årsag, pris, antal);
  // alt andet, også et kort hvis antal er ændret imens, bliver liggende urørt og kontrolleres ved næste tryk.
  function settleBinder(snapshot, left) {
    var snap = Object.create(null), leftById = Object.create(null);
    snapshot.forEach(function (it) { snap[String(it.variantId)] = it; });
    left.forEach(function (it) { leftById[String(it.variantId)] = it; });
    commit(function (base) {
      var next = [];
      base.forEach(function (it) {
        var id = String(it.variantId);
        if (!snap[id] || snap[id].qty !== it.qty) { next.push(it); return; }
        if (leftById[id]) next.push(leftById[id]);
      });
      return next;
    }, { fromRun: true, noUndo: true });
    undo = [];
  }
  function addToCart() {
    if (busy || asking) return;
    if (sync()) render();
    if (!items.length) return;
    exclusive(function () {
      // Kørslen starter fra den binder, der står gemt, når låsen er taget.
      return locked(function () { if (sync()) render(); return checkout(items, { fromBinder: true }); });
    }).then(function (report) {
      redraw(); // de viste kort følger de friske lagerdata fra kørslen
      var faerre = report.problems.some(function (p) { return p.code === 'faerre'; });
      // Binderen blev tømt i en anden fane, før kørslen startede: der var intet at lægge i.
      if (!report.left.length && report.added + report.already === 0) return;
      // Binderen er gemt (settleBinder i checkout), før kunden sendes videre. Kun når der blev lagt kort i ved dette tryk,
      // binderen er tom, intet lå i kurven i forvejen, intet antal er sat ned, og udfaldet er kendt. I alle andre tilfælde
      // vises kvitteringen: lå et kort i kurven i forvejen, er der ikke lagt flere i, og det skal kunden have at vide.
      if (report.added > 0 && !items.length && report.already === 0 && !faerre && !report.blind) { window.location.href = ROOTURL + 'cart'; return; }
      showReceipt(report);
    }).then(null, function (e) {
      toast(e && e.message === 'anden-fane' ? OTHER_TAB : 'Noget gik galt. Prøv igen. Intet lægges i kurven to gange.');
    });
  }
  // En binder, der er over 30 minutter gammel (eller uden tidsstempel), kontrolleres mod friske data, når værktøjet åbnes.
  // Kurven røres ikke og læses ikke: derfor en tom kurv ({}) til kernen her, og kun her.
  // Kontrollen skriver lager-oplysninger (solgt, antal sat ned, højeste antal) og prisfald ind i binderen. Er standen ændret,
  // eller er kortet blevet dyrere, sættes KUN flaget: pris og stand bliver stående, som kunden så dem. Så holder selve trykket
  // på Læg i kurv kortet tilbage én gang og viser ændringen i kvitteringen; en højere pris går aldrig stille i kurven.
  // Et kort, hvis produkt ikke kunne hentes, røres ikke (der gemmes ikke "Kunne ikke tjekke lager"), og binderens tidsstempel
  // fornyes kun, når alle kort blev tjekket: ellers prøves der igen, næste gang værktøjet åbnes.
  function checkStale() {
    if (busy || asking || !items.length || (savedAt && Date.now() - savedAt <= STALE_MS)) return;
    var handles = uniq(items.map(function (it) { return it.handle; })), mine = runs;
    fetchFresh(handles).then(function (fresh) {
      // Er en kurv-kørsel startet, siden kontrollen begyndte (også én, der er færdig igen), har den selv kontrolleret: svaret kasseres.
      // Kom der intet svar (uden net), prøves igen næste gang.
      if (busy || asking || runs !== mine || !handles.some(function (h) { return fresh[h]; })) return;
      var n = 0, all = handles.every(function (h) { return fresh[h]; });
      // Kun de kort, der blev kontrolleret, opdateres; kort lagt i imens (her eller i en anden fane) bliver liggende urørt.
      commit(function (base) {
        var rec = K.reconcile(base.filter(function (it) { return !!fresh[it.handle]; }), fresh, {}), byId = Object.create(null), changed = Object.create(null), hold = Object.create(null);
        rec.items.forEach(function (it) { byId[String(it.variantId)] = it; });
        rec.problems.forEach(function (p) {
          var id = String(p.item.variantId);
          if (p.code === 'stand' || p.code === 'pris') hold[id] = 1;
          if (p.code !== 'tjek' && !changed[id]) { changed[id] = 1; n++; }
        });
        return base.map(function (it) {
          var id = String(it.variantId), r = byId[id];
          if (!r) return it;
          return hold[id] ? Object.assign({}, r, { cond: it.cond, price: it.price }) : r;
        });
      }, { noUndo: true, keepTime: !all });
      redraw(); // de viste kort følger de friske lagerdata
      if (n) toast(n + ' kort i din binder har ændret sig. Se de markerede lommer.');
    }).then(null, function () {});
  }

  /* ---------- kvittering ---------- */
  // Udgavens andre tilgængelige stande i de friske data. Aldrig en anden udgave eller et andet sprog.
  function swapChoices(item) {
    var p = products[item.handle], ts = p ? K.tiles(p) : [];
    for (var i = 0; i < ts.length; i++) {
      if (ts[i].ed === item.ed && ts[i].lang === item.lang) {
        return { tile: ts[i], variants: K.standSummary(ts[i]).filter(function (v) { return String(v.id) !== String(item.variantId); }) };
      }
    }
    return { tile: null, variants: [] };
  }
  // Én række pr. kort, der ikke kom i kurven. w: kernens problemer for kortet, slået op på kode.
  // blind: udfaldet er ukendt, så kortet kan ligge i kurven: der tilbydes ikke en anden stand (det kunne give kortet to gange).
  function kvRowHTML(it, w, blind) {
    var id = esc(String(it.variantId)), d = K.describe(it), note = [], acts = '', chips = '';
    if (w.stand) note.push('Nu ' + it.cond + (w.stand.fra ? ', før ' + w.stand.fra : ''));
    if (w.pris) note.push('Ny pris ' + fmtKr(it.price) + ', før ' + fmtKr(w.pris.fra));
    if (w.stand || w.pris) acts += '<button type="button" class="mtwc-btn mtwc-kvbtn mtwc-pri" data-kv-keep="' + id + '">' + esc(w.stand && it.cond ? 'Behold i ' + it.cond : 'Behold til ny pris') + '</button>';
    // Kunne kortet ikke kontrolleres, er der ingen friske data at vælge en anden stand ud fra.
    var alt = w.tjek || blind ? [] : swapChoices(it).variants;
    if (alt.length) {
      acts += '<button type="button" class="mtwc-btn mtwc-kvbtn" data-kv-swap="' + id + '" aria-expanded="false">Vælg anden stand</button>';
      chips = '<div class="mtwc-kvchips" data-kv-chips hidden>' + alt.map(function (v) {
        var a = K.abbr(v), lbl = esc('Byt til ' + variantLabel(v));
        return '<button type="button" class="mtwc-condchip" data-kv-pick="' + esc(String(v.id)) + '" title="' + lbl + '" aria-label="' + lbl + '">' +
          (a ? esc(a) + ' ' : '') + '<span class="p">' + fmtNum(v.price) + '</span></button>';
      }).join('') + '</div>';
    }
    acts += '<button type="button" class="mtwc-btn mtwc-kvbtn" data-kv-rm="' + id + '">Fjern</button>';
    return '<div class="mtwc-kvrow" data-kv-row="' + id + '">' +
      // Uden loading="lazy": rækken skrives, mens panelet er skjult, og et udskudt billede kom aldrig frem i butikken.
      // 360 px: samme fil som lommen i binderen, så den oftest allerede er hentet.
      '<div class="mtwc-kvimg">' + (it.img ? '<img src="' + esc(img(it.img, 360)) + '" alt="" decoding="async">' : '<span class="mtwc-ph">🃏</span>') + '</div>' +
      '<div class="mtwc-kvtxt"><b class="mtwc-kvname">' + esc(it.title || it.handle) + '</b>' +
      (d ? '<span class="mtwc-kvdesc">' + esc(d) + '</span>' : '') +
      '<span class="mtwc-kvwhy">' + esc(it.flag || 'Kunne ikke lægges i kurven') + '</span>' +
      (note.length ? '<span class="mtwc-kvnote">' + esc(note.join(' · ')) + '</span>' : '') + chips + '</div>' +
      '<div class="mtwc-kvacts">' + acts + '</div></div>';
  }
  var KV_FOLD = 10; // over så mange rækker med samme årsag vises én samlet linje med "Vis alle"
  // Rækkerne samlet pr. årsag (i den rækkefølge, årsagerne først optræder). Tallet på den samlede linje tæller kort, ikke rækker.
  function kvListHTML(left, why, blind) {
    var by = Object.create(null), order = [];
    left.forEach(function (it) {
      var reason = it.flag || 'Kunne ikke lægges i kurven';
      if (!by[reason]) { by[reason] = []; order.push(reason); }
      by[reason].push(it);
    });
    return order.map(function (reason) {
      var rows = by[reason].map(function (it) { return kvRowHTML(it, why[String(it.variantId)] || {}, blind); }).join('');
      if (by[reason].length <= KV_FOLD) return rows;
      return '<div class="mtwc-kvrow" data-kv-sum><div class="mtwc-kvtxt"><b class="mtwc-kvname">' + K.count(by[reason]) + ' kort:</b>' +
        '<span class="mtwc-kvwhy">' + esc(reason) + '</span></div>' +
        '<div class="mtwc-kvacts"><button type="button" class="mtwc-btn mtwc-kvbtn" data-kv-all>Vis alle</button></div></div>' +
        '<div data-kv-group hidden>' + rows + '</div>';
    }).join('');
  }
  // Mens kvitteringen er åben, er resten af værktøjet spærret (inert), så knapperne bag panelet ikke kan nås med Tab eller trykkes.
  function setInert(on) {
    $$('.mtwc-bar, .mtwc-stage, .mtwc-dock, .mtwc-tabs').forEach(function (el) { if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); });
  }
  // Blivende panel efter kørslen. Lukkes med "Bliv her" eller Esc; fokus ind på titlen og tilbage på kurv-knappen.
  // Så længe panelet er åbent, bliver Tab inde i det (se trapReceipt). Alle tal tæller kort (antal lagt sammen), ikke rækker.
  // report.blind: kurven kunne ikke læses efter et fejlet kald. Så siger panelet kun det, vi ved: mindst så mange kort kom i.
  function showReceipt(report) {
    var m = $('[data-mtwc-modal="kvittering"]'), why = Object.create(null), faerre = 0, sub = [], left = K.count(report.left), title;
    if (!m) return;
    report.problems.forEach(function (p) {
      var id = String(p.item.variantId);
      (why[id] = why[id] || {})[p.code] = p;
      if (p.code === 'faerre') faerre++;
    });
    if (report.blind) {
      title = report.added > 0 ? 'Mindst ' + report.added + ' kort lagt i kurven' : 'Vi fik ikke svar fra kurven';
      sub.push('Vi ved ikke, om alle kort kom i kurven. Tryk på Læg i kurv igen. Intet lægges i to gange.');
    } else {
      title = report.added > 0 ? report.added + ' kort lagt i kurven' : report.already > 0 && !left ? 'Kortene lå allerede i kurven' : 'Ingen kort blev lagt i kurven';
      if (left) sub.push(left + ' kort kunne ikke lægges i og ligger stadig i binderen.');
    }
    if (report.already > 0) sub.push(report.already + ' lå allerede i kurven. Vil du have flere af ' + (report.already === 1 ? 'det' : 'dem') + ', så sæt antallet op i kurven.');
    if (faerre) sub.push(faerre + ' kort var der færre af end ønsket; antallet er sat ned.');
    if (!report.left.length && items.length) sub.push('Der er lagt kort i binderen fra en anden fane imens. De er ikke lagt i kurven endnu.');
    $('[data-mtwc-kv-title]').textContent = title;
    $('[data-mtwc-kv-sub]').textContent = sub.join(' ');
    $('[data-mtwc-kv-list]').innerHTML = kvListHTML(report.left, why, report.blind);
    // Kurven har indhold, når noget kom i nu, lå der fra et tidligere tryk, eller kan være kommet i uden svar.
    $('[data-mtwc-kv-cart]').hidden = !(report.blind || report.cartHad || report.added + report.already > 0);
    m.hidden = false;
    setInert(true);
    $('[data-mtwc-kv-title]').focus();
  }
  // Spærringen fjernes altid, også når panelet allerede er skjult ad anden vej.
  function closeReceipt() {
    var m = $('[data-mtwc-modal="kvittering"]');
    setInert(false);
    if (!m || m.hidden) return;
    m.hidden = true;
    var b = $('[data-mtwc-addcart]');
    if (b.disabled) b = $('[data-mtwc-close]');
    if (b) b.focus();
  }
  // Tab og Shift+Tab går rundt mellem panelets knapper og forlader det ikke.
  function trapReceipt(e) {
    var m = $('[data-mtwc-modal="kvittering"]');
    if (!m || m.hidden) return;
    var els = $$('button, a[href]', m).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!els.length) { e.preventDefault(); return; }
    var first = els[0], last = els[els.length - 1], at = document.activeElement, inside = m.contains(at) && els.indexOf(at) > -1;
    if (e.shiftKey ? (!inside || at === first) : (at === last || (!inside && !m.contains(at)))) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  }
  // Rækken er afgjort: knapperne væk, årsagen erstattet af det, der skete. Kortet ligger stadig i binderen, ikke i kurven.
  function kvDone(row, text) {
    var list = $('[data-mtwc-kv-list]'), w = row.querySelector('.mtwc-kvwhy');
    row.classList.add('mtwc-kvdone');
    if (w) w.textContent = text;
    $$('.mtwc-kvacts,.mtwc-kvnote,[data-kv-chips]', row).forEach(function (el) { el.remove(); });
    if (!list.querySelector('.mtwc-kvhint')) {
      var h = document.createElement('p');
      h.className = 'mtwc-kvhint';
      h.textContent = 'Kort, du har byttet eller beholdt, ligger i binderen. Tryk på Læg i kurv igen for at få dem med.';
      list.appendChild(h);
    }
    $('[data-mtwc-kv-title]').focus();
  }
  function kvClick(t) {
    if (t.closest('[data-mtwc-kv-stay]')) { closeReceipt(); return; }
    var all = t.closest('[data-kv-all]'), sum = all && all.closest('[data-kv-sum]');
    if (sum) {
      // "Vis alle": rækkerne bag den samlede linje foldes ud; linjen selv bliver stående uden knap.
      if (sum.nextElementSibling) sum.nextElementSibling.hidden = false;
      all.remove();
      $('[data-mtwc-kv-title]').focus();
      return;
    }
    var b = t.closest('[data-kv-rm],[data-kv-keep],[data-kv-swap],[data-kv-pick]'), row = b && b.closest('[data-kv-row]');
    if (!row) return;
    var id = row.getAttribute('data-kv-row');
    function gone() { row.remove(); $('[data-mtwc-kv-title]').focus(); }
    if (b.hasAttribute('data-kv-rm')) { commit(function (base) { return K.setQty(base, id, 0); }); gone(); return; }
    if (b.hasAttribute('data-kv-swap')) {
      var box = row.querySelector('[data-kv-chips]');
      if (box) { box.hidden = !box.hidden; b.setAttribute('aria-expanded', box.hidden ? 'false' : 'true'); }
      return;
    }
    // Ændringerne lægges oven på den gemte binder. Er kortet ikke længere i den (fjernet i en anden fane), har rækken intet at virke på.
    var it = null, r = null;
    if (b.hasAttribute('data-kv-keep')) {
      commit(function (base) {
        var i = K.indexOf(base, id);
        if (i < 0) return base;
        it = Object.assign({}, base[i], { flag: '' });
        return base.map(function (x, xi) { return xi === i ? it : x; });
      }, { noUndo: true });
      if (!it) { gone(); return; }
      undo = []; // et ældre trin ville lægge kortet tilbage til den gamle pris eller stand
      kvDone(row, 'Beholdt: ' + (K.describe(it) ? K.describe(it) + ' · ' : '') + fmtKr(it.price));
      return;
    }
    // Tryk på en stand-chip: netop den stand i samme udgave erstatter kortet i binderen.
    var pick = b.getAttribute('data-kv-pick'), v = null;
    commit(function (base) {
      var i = K.indexOf(base, id), c = i < 0 ? null : swapChoices(base[i]);
      it = i < 0 ? null : base[i];
      v = c && c.tile ? K.variantById(c.tile, pick) : null;
      if (!v || !v.available) return base;
      r = K.add(K.setQty(base, id, 0), K.makeItem(c.tile, v));
      return r.result === 'added' || r.result === 'inc' ? r.items : base;
    });
    if (!it) { gone(); return; }
    if (!r) { toast(SOLD_TEXT); return; } // standen findes ikke længere på lager i de friske data
    if (r.result !== 'added' && r.result !== 'inc') { toast(r.result === 'full' ? FULL_TEXT : maxText(v.qty)); return; }
    kvDone(row, 'Byttet til ' + (v.hasCond === false || !v.cond ? '' : v.cond + ' · ') + fmtKr(v.price));
  }

  // En kontekst udefra (loaderen, history.state) går gennem samme regler som et link (K.deeplink): et ugyldigt handle
  // eller en ulæselig søgetekst giver forsiden. Uden ctx: forsiden.
  function ctxOk(c) {
    var m = c && c.mangler === true ? '&mangler=1' : '';
    try {
      if (c && (c.mode === 'saet' || c.mode === 'kol') && typeof c.handle === 'string') return K.deeplink(c.mode + '=' + encodeURIComponent(c.handle) + m);
      if (c && c.mode === 'q' && typeof c.q === 'string') return K.deeplink('q=' + encodeURIComponent(c.q) + m);
    } catch (e) {}
    return K.deeplink('aabn=1' + m);
  }

  /* ---------- API til broen (mtw-samling-binder.js) ---------- */
  window.MTWC = {
    // Direkte link: { mode, handle, q, mangler } fra K.deeplink, mens værktøjet står åbent efter linket; ellers null.
    direkte: direkte,
    // Overlay: åbn værktøjet med ctx = { mode, handle, q, mangler } (K.deeplink af indgangens link; uden ctx: forsiden).
    // sted: indgangens navn (data-mtwkv) til målingen; huskes resten af besøget. Uden sted (genåbning fra historikken): det huskede.
    // Står det allerede åbent, skiftes kun indholdet. Bagefter sendes hændelsen mtwc:aabnet (detail: ctx), så broen kan
    // reagere på mangler ved hver åbning. Svarer false, når intet blev åbnet (ikke overlay, eller kurv-kørslen er i gang).
    // Hændelsen sendes lidt efter: kaldes open fra et klik, må broens "klik udenfor lukker" ikke ramme dens menu.
    open: function (ctx, sted) {
      if (!OVERLAY || busy || asking || leaving) return false;
      var k = validKilde(sted);
      if (k) { kilde = k; try { sessionStorage.setItem(KILDE_KEY, k); } catch (e) {} }
      var d = direkte = window.MTWC.direkte = ctxOk(ctx);
      if (isOpen) { fill(); markHistory(); } else openApp(!!sted); // uden sted: genåbning fra historikken
      setTimeout(function () { try { document.dispatchEvent(new CustomEvent('mtwc:aabnet', { detail: d })); } catch (e) {} }, 0);
      return true;
    },
    // Køb uden om binderen (Mine samlinger: "Læg alle manglende i kurven"). Pr. kort kun den almindelige udgave
    // (Normal/engelsk). Binderen røres ikke. Reglen er den samme som ved et tryk på kortet (addShown):
    // det, der lægges i kurven, er det, kunden fik vist.
    //   Står kortets almindelige udgave tegnet i resultatlisten ved trykket, købes kun netop den variant, kortet viser som valgt
    //     (data-pick: den billigste inden for stand-grænsen, eller kundens eget valg i kortets vælger). Giver de friske data en
    //     anden variant (den viste er solgt, eller en anden er blevet den billigste) eller en højere pris på samme variant, købes INTET:
    //     kortet gives tilbage i changed.
    //   Er kortet ikke tegnet, købes den billigste variant inden for stand-grænsen (K.pick); et ældre valg i en vælger bruges ikke.
    //   outside: intet at købe (udsolgt, kun uden for stand-grænsen, kun en anden udgave, eller ikke et enkeltkort).
    //   unchecked: produktet kunne ikke hentes (netværk, 429/430/5xx, tidsgrænse). De er IKKE udsolgt, vi ved det bare ikke.
    // Intet i changed, outside og unchecked er sendt til kurven.
    // Svar: { added, already, left, problems, blind, cartHad, outside, unchecked, changed } (se checkout). Afviser med Error('optaget'),
    // når en kørsel er i gang i denne fane, og med Error('anden-fane'), når en anden fane lægger i kurven lige nu. I begge tilfælde er intet sendt.
    // Master set: rhHandles (valgfri) er kort, hvor Reverse Holo-udgaven på engelsk købes efter samme regel (K.udgaveTile).
    //   I outside, unchecked og changed står de som 'rh:' + handle; i left bærer kortet selv sin udgave (ed).
    checkoutHandles: function (handles, rhHandles) {
      if (busy || asking) return Promise.reject(new Error('optaget'));
      handles = uniq(handles);
      var rhListe = uniq(rhHandles);
      // Det, kortene viser lige nu, læses FØR lagerkontrollen: "handle|udgave|sprog" -> data-pick for hvert tegnet kort.
      var shown = Object.create(null), shownPrice = Object.create(null);
      $$('.mtwc-result', $('[data-mtwc-results]')).forEach(function (li) {
        var h0 = li.getAttribute('data-handle'), k = h0 + '|' + li.getAttribute('data-tile'), pick = li.getAttribute('data-pick') || '';
        (shown[k] = shown[k] || []).push(pick);
        // Også den viste pris huskes: stiger prisen på samme variant inden købet, er det ikke længere det, kunden fik vist.
        var v0 = pick && products[h0] ? K.variantById(products[h0], pick) : null;
        if (v0) shownPrice[k] = v0.price;
      });
      return exclusive(function () {
        return locked(function () {
          return fetchFresh(uniq(handles.concat(rhListe))).then(function (fresh) {
            var list = [], outside = [], unchecked = [], changed = [];
            function koeb(h, udgave, id) {
              var p = fresh[h];
              if (!p) { unchecked.push(id); return; }
              var t0 = isSingle(p.type) ? K.udgaveTile(p, udgave) : null, picks = null, v = null;
              if (t0) {
                picks = shown[h + '|' + t0.key] || null;
                v = picks ? choiceOf(t0, K.standSummary(t0)) : K.pick(t0, limit);
              }
              if (!v) { outside.push(id); return; }
              if (picks && picks.some(function (pid) { return pid !== String(v.id); })) { changed.push(id); return; }
              if (picks && shownPrice[h + '|' + t0.key] != null && v.price > shownPrice[h + '|' + t0.key]) { changed.push(id); return; }
              // Samme variant sendes aldrig to gange; kortet beholder det handle, broen spurgte på.
              if (K.indexOf(list, v.id) < 0) list.push(Object.assign(K.makeItem(t0, v), { handle: h }));
            }
            handles.forEach(function (h) { koeb(h, 'normal', h); });
            rhListe.forEach(function (h) { koeb(h, 'rh', 'rh:' + h); });
            return checkout(list, { fromBinder: false, fresh: fresh }).then(function (rep) { rep.outside = outside; rep.unchecked = unchecked; rep.changed = changed; return rep; });
          });
        });
      }).then(function (rep) {
        redraw(); // de viste kort følger de friske lagerdata, så broens optælling passer efter købet
        return rep;
      });
    }
  };

  /* ---------- toast ---------- */
  var toastT;
  // ms = Infinity: beskeden bliver stående, til den næste besked erstatter den (eller den fjernes af den, der satte den).
  // En knap i beskeden (Fortryd) kan trykkes, så længe beskeden står (.mtwc-toast--act); ellers går tryk igennem den.
  function toast(html, ms) {
    var t = $('[data-mtwc-toast]'); t.innerHTML = html; t.classList.add('show'); clearTimeout(toastT);
    t.classList.toggle('mtwc-toast--act', !!t.querySelector('button'));
    if (ms !== Infinity) toastT = setTimeout(function () { t.classList.remove('show'); }, ms || 2400);
  }

  /* ---------- open / close ---------- */
  var isOpen = false;
  // maal: en rigtig åbning (indgang, sidens knap, direkte link), som måles. Genåbning fra historikken (tilbage/frem,
  // genindlæst, bfcache) måles ikke.
  function openApp(maal) {
    if (isOpen) return; isOpen = true;
    // Overlay: husk, hvor kunden stod (rulning, fokus) og kurv-kørslerne, og læg et trin i historikken (se markHistory).
    if (OVERLAY) { scrollY0 = window.pageYOffset || 0; focus0 = keyFocus(); cartChanged = false; markHistory(); }
    $('[data-mtwc-app]').hidden = false;
    document.documentElement.classList.add('mtwc-lock');
    render();
    checkStale();
    fill();
    if (maal) track('kortvaelger_aabnet', { sted: kilde, visning: direkte ? direkte.mode : 'forside' });
    setTimeout(function () { var i = $('[data-mtwc-input]'); if (i) i.focus(); }, 60);
  }
  // Direkte link: åbningen viser linkets indhold med ét kald (forsiden hentes ikke først). direkte er kun sat ved den
  // åbning: den nulstilles, når kunden lukker til landingssiden, og senere åbninger går den almindelige vej nedenfor.
  // Overlayet åbnes altid med en kontekst; også forsiden viser forsiden, selvom en ældre søgning står i feltet.
  // Forsiden med mangler og en indlogget kunde: forsiden hentes ikke, for broen kører straks en søgning på binderens mangler
  // (eller åbner binder-menuen). Er der efter 4 sekunder stadig intet i listen eller feltet, vises forsiden alligevel.
  var manglerT = null;
  function fill() {
    var inp = $('[data-mtwc-input]');
    clearTimeout(manglerT);
    if (OVERLAY) { // mobil: start på søgefanen, så indholdet ses
      $('[data-mtwc-stage]').classList.remove('mtwc-show-binder');
      $$('[data-mtwc-tab]').forEach(function (b) { b.classList.toggle('mtwc-on', b.getAttribute('data-mtwc-tab') === 'search'); });
    }
    if (direkte && direkte.mode === 'saet') { inp.value = ''; loadCollection(direkte.handle, $('[data-mtwc-setbrowse]'), { numbered: true }); }
    else if (direkte && direkte.mode === 'kol') { inp.value = ''; setChipActive(null); loadCollection(direkte.handle, null); }
    else {
      if (direkte && direkte.mode === 'q') { inp.value = direkte.q; setChipActive(null); }
      else if (OVERLAY && direkte) inp.value = '';
      if (direkte && direkte.mode === 'forside' && direkte.mangler && document.querySelector('script[data-mtwsb][data-logged-in="1"]')) {
        inp.value = ''; setChipActive(null); setView(''); showHint('Henter dine manglende kort …');
        manglerT = setTimeout(function () { if (isOpen && !inp.value.trim() && !$('[data-mtwc-results]').children.length) showFeatured(); }, 4000);
        return;
      }
      // Søgningen køres igen ved genåbning: lukningen kan have afbrudt den midt i et kald.
      var q = inp.value.trim();
      if (q.length >= MIN_CHARS) search(q); else showFeatured();
    }
  }
  // Overlay og tilbage-knappen (mobil): åbningen lægger et trin i historikken med konteksten, så "tilbage" lukker værktøjet
  // i stedet for at forlade siden. Står værktøjets trin allerede øverst (tilbage fra kurven, genindlæst side), erstattes det.
  // ownStep: denne side har selv lagt trinnet (pushState), så tilbage herfra bliver på siden. Er trinnet genåbnet fra
  // historikken (genindlæst, tilbage fra kurven uden bfcache), ville history.back hente siden igen.
  var pushed = false, ownStep = false, scrollY0 = 0, focus0 = null;
  // Fokus gives kun tilbage, når kunden bruger tastaturet (:focus-visible). Efter et museklik ville fokus på et menupunkt
  // åbne menuen igen (temaets :focus-within).
  function keyFocus() {
    var a = document.activeElement;
    try { return a && a !== document.body && a.matches(':focus-visible') ? a : null; } catch (e) { return null; }
  }
  function markHistory() {
    try {
      var st = { mtwcOverlay: 1, ctx: direkte };
      if (history.state && history.state.mtwcOverlay) history.replaceState(st, ''); else { history.pushState(st, ''); ownStep = true; }
      pushed = true;
    } catch (e) { pushed = false; }
  }
  // Efter et direkte link har kunden aldrig set landingssiden. Kom kunden fra en side i butikken, går luk tilbage dertil,
  // og værktøjet bliver stående, mens browseren skifter side, så landingssiden ikke blinker. Ellers (udefra, ny fane uden
  // historik, eller samme side) vises landingssiden, og parametrene fjernes fra adressen: herfra er det et almindeligt besøg.
  var leaving = null; // tidsgrænse, mens browseren går tilbage: nye luk-tryk ignoreres, så der ikke gås to sider tilbage
  function fromShop() {
    var ref = document.referrer || '', own = location.origin + '/';
    return history.length > 1 && ref.indexOf(own) === 0 && ref.slice(own.length - 1).split(/[?#]/)[0] !== location.pathname;
  }
  function closeApp() {
    if (busy || asking || leaving) return; // værktøjet bliver åbent, til kurv-kørslen er færdig
    closeReceipt();
    if (OVERLAY) {
      // Værktøjets trin står øverst: luk = ét trin tilbage, og popstate nedenfor skjuler værktøjet, så historikken ikke vokser.
      // Kommer popstate ikke inden for et sekund (historikken er ændret af andre), skjules det alligevel, men uden at genindlæse
      // kurvsiden: gåturen tilbage kan stadig være på vej.
      if (!pushed || !history.state || !history.state.mtwcOverlay) { hideApp(); return; }
      if (!ownStep) { // trinnet er ikke lagt af denne side: ryd det i stedet for at gå tilbage (det ville hente siden igen)
        pushed = false;
        try { history.replaceState(null, ''); } catch (e) {}
        hideApp();
        return;
      }
      leaving = setTimeout(function () { leaving = null; pushed = ownStep = false; if (isOpen && !busy && !asking) hideApp(true); }, 1000);
      history.back();
      return;
    }
    if (direkte && fromShop()) {
      // Blev browseren stående alligevel (forrige trin var samme side), vises landingssiden i stedet for en død luk-knap.
      leaving = setTimeout(function () { leaving = null; if (!busy && !asking) hideApp(); }, 8000);
      // Er der lagt i kurven, hentes forrige side frisk (history.back kunne vise en gemt kurvside med den gamle kurv).
      if (cartChanged) location.replace(document.referrer); else history.back();
      return;
    }
    hideApp();
  }
  // venter: overlayet skjules, mens en gåtur tilbage måske stadig er på vej (se closeApp).
  function hideApp(venter) {
    isOpen = false; $('[data-mtwc-app]').hidden = true; document.documentElement.classList.remove('mtwc-lock'); if (searchCtl) searchCtl.abort();
    dropBulkToast(); // Fortryd fra "Læg alle" hører til værktøjet, ikke landingssiden
    if (OVERLAY) { hideOverlay(venter); return; }
    if (!direkte) return;
    direkte = window.MTWC.direkte = null;
    document.documentElement.classList.remove('mtwc-direkte');
    // Kun linkets egne parametre fjernes; andre (fx preview_theme_id, utm_*) bliver stående.
    try {
      var rest = location.search.replace(/^\?/, '').split('&').filter(function (part) {
        return part && !/^(aabn|saet|kol|q|mangler)(=|$)/.test(part);
      }).join('&');
      history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
    } catch (e) {}
  }
  // Overlay lukket: dialogerne og beskeden står uden for [data-mtwc-app] og skal også væk (tilbage-knappen kan lukke midt i en
  // dialog). Kunden står, hvor de stod: samme rulning og (med tastatur) fokus tilbage på indgangen. Er der lagt i kurven, mens værktøjet
  // var åbent, hentes kurvsiden igen; på andre sider opdateres kurv-tallet i headeren med temaets egen cartCountUpdate (cart.js).
  // Kan en gåtur tilbage stadig være på vej (venter), genindlæses kurvsiden ikke: det kunne åbne trinnet, der lige blev lukket.
  // Hændelsen mtwc:lukket fortæller broen, at dens besked og menu skal væk fra siden.
  function hideOverlay(venter) {
    closeReceipt();
    $$('[data-mtwc-modal]').forEach(function (m) { m.hidden = true; });
    $('[data-mtwc-toast]').classList.remove('show');
    direkte = window.MTWC.direkte = null;
    if (Math.abs((window.pageYOffset || 0) - scrollY0) > 1) window.scrollTo(0, scrollY0);
    try { if (focus0 && focus0.focus && document.body.contains(focus0)) focus0.focus({ preventScroll: true }); } catch (e) {}
    focus0 = null;
    clearTimeout(manglerT);
    try { document.dispatchEvent(new CustomEvent('mtwc:lukket')); } catch (e) {}
    if (!cartChanged) return;
    cartChanged = false;
    if (/\/cart\/?$/.test(location.pathname)) { if (!venter) location.reload(); return; }
    if (typeof window.cartCountUpdate !== 'function') return;
    fetch(ROOTURL + 'cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === 'number') window.cartCountUpdate(c.item_count); })
      .then(null, function () { /* tallet i headeren opdateres ved næste sideskift */ });
  }
  // Tilbage-knappen, mens overlayet er åbent: værktøjets trin er væk, så værktøjet lukkes. Er kurv-kørslen i gang, bliver
  // værktøjet åbent, og trinnet lægges tilbage.
  // Frem-knappen efter et luk: værktøjets trin står øverst igen, mens værktøjet er lukket. Det åbnes med trinnets indhold
  // (gennem MTWC.open, så konteksten tjekkes som et link), og trinnet regnes som sidens eget: popstate betyder samme side.
  window.addEventListener('popstate', function () {
    if (!OVERLAY) return;
    var st = history.state;
    if (st && st.mtwcOverlay) { if (!isOpen && window.MTWC.open(st.ctx)) ownStep = true; return; }
    if (!pushed) return;
    pushed = ownStep = false; clearTimeout(leaving); leaving = null;
    if (!isOpen) return;
    if (busy || asking) { markHistory(); return; }
    hideApp();
  });
  // Siden forlades (også ind i bfcache): tidsgrænsen må ikke lukke værktøjet, hvis kunden senere går frem til siden igen.
  window.addEventListener('pagehide', function () { clearTimeout(leaving); leaving = null; });
  // Tilbage fra bfcache med klassen fra det direkte link stående: siden må ikke stå tom. Åbn igen, eller vis landingssiden.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || isOpen || !document.documentElement.classList.contains('mtwc-direkte')) return;
    if (direkte) openApp(); else document.documentElement.classList.remove('mtwc-direkte');
  });

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (busy || asking) return; // mens der lægges i kurven: ingen ændringer, intet nyt tryk, og værktøjet kan ikke lukkes
    if (t.closest('[data-mtwc-modal="kvittering"]')) { kvClick(t); return; }
    var openBtn = t.closest('[data-mtwc-open]'); if (openBtn) { openApp(true); return; }
    if (t.closest('[data-mtwc-close]')) { closeApp(); return; }
    // Kortets stand-vælger åbner sig selv. Et tryk på den lægger aldrig noget i (valget håndteres i 'change' nedenfor).
    if (t.closest('[data-standsel]')) return;
    // Afklaring i liste-import: kortene her ligner resultatlistens, men et valg lægger linjens antal i og afgør rækken.
    var clrow = t.closest('[data-clrow]'); if (clrow) { e.preventDefault(); clarifyClick(t, clrow); return; }
    // Tryk på kortet eller "+": den variant, kortet viser som valgt.
    var pa = t.closest('[data-pickadd]');
    if (pa) { e.preventDefault(); addShown(pa.closest('.mtwc-result')); return; }
    var pocket = t.closest('[data-variant-id]');
    if (pocket) {
      var pid = pocket.getAttribute('data-variant-id'), pi = K.indexOf(items, pid), qb = t.closest('[data-qty]');
      if (pi < 0) return;
      if (t.closest('[data-rm]')) { e.preventDefault(); commit(function (base) { return K.setQty(base, pid, 0); }); focusPocket(pi); }
      else if (qb) {
        var up = qb.getAttribute('data-qty') === '1';
        if (qb.getAttribute('aria-disabled') === 'true') { toast(maxText(items[pi].max)); return; }
        if (up && K.count(items) >= K.CAP) { toast(FULL_TEXT); return; }
        var wrote = commit(function (base) { var bi = K.indexOf(base, pid); return bi < 0 ? base : K.setQty(base, pid, base[bi].qty + (up ? 1 : -1)); });
        // Minus til nul fjernede kortet: fokus på lommen, der nu står på pladsen. Ellers tilbage på antal-knappen.
        if (K.indexOf(items, pid) < 0) focusPocket(pi); else focusQty(pid, up);
        if (wrote && up && roomText(K.count(items))) toast(roomText(K.count(items)));
      }
      return;
    }
    var pd = t.closest('[data-page]'); if (pd) { goToPage(parseInt(pd.getAttribute('data-page'), 10)); return; }
    if (t.closest('[data-mtwc-prev]')) { goToPage(cur - 1); return; }
    if (t.closest('[data-mtwc-next]')) { goToPage(cur + 1); return; }
    if (t.closest('[data-mtwc-undo]')) {
      // Fortryd lægger en færdig liste tilbage; det gælder kun, når ingen anden fane har skrevet imens (se commit).
      // Bagefter vises den første side, der blev ændret, så man ser, hvad der kom tilbage.
      if (!undo.length) { toast('Intet at fortryde'); return; }
      var was = items;
      if (commit(undo.pop(), { noUndo: true })) { goToPage(firstChangedPage(was, items)); toast('Fortrudt'); }
      return;
    }
    // Ryd side og ryd alt spørger ikke først: Fortryd giver kortene tilbage.
    if (t.closest('[data-mtwc-clearpage]')) {
      if (items.length > cur * 9) {
        var onPage = Object.create(null); // sidens kort (på variantId), så en anden fanes kort ikke ryger med
        items.slice(cur * 9, cur * 9 + 9).forEach(function (it) { onPage[String(it.variantId)] = 1; });
        if (commit(function (base) { return base.filter(function (it) { return !onPage[String(it.variantId)]; }); })) toast('Side ryddet · Fortryd for at få kortene tilbage');
      }
      return;
    }
    if (t.closest('[data-mtwc-clearall]')) {
      if (items.length && commit(function () { return []; })) toast('Binderen er tømt · Fortryd for at få kortene tilbage');
      return;
    }
    if (t.closest('[data-mtwc-paste]')) { $('[data-mtwc-modal="paste"]').hidden = false; return; }
    if (t.closest('[data-mtwc-pasterun]')) { runPaste(); return; }
    if (t.closest('[data-mtwc-viewclear]')) { clearView(); return; }
    if (t.closest('[data-mtwc-addall]')) { addAll(); return; }
    if (t.closest('[data-mtwc-setbrowse]')) { openSetBrowser(); return; }
    var nw = t.closest('[data-mtwc-newest]'); if (nw) { showNewestSet(nw); return; }
    var chc = t.closest('[data-mtwc-chase]'); if (chc) { showChase(chc); return; }
    var rnd = t.closest('[data-mtwc-random]'); if (rnd) { showRandom(rnd, 0); return; }
    if (t.closest('[data-mtwc-artistbrowse]')) { openArtistBrowser(); return; }
    var arow = t.closest('[data-artistrow]'); if (arow) { pickArtist(arow.getAttribute('data-artistrow')); return; }
    var srow = t.closest('[data-setrow]'); if (srow) { pickSet(srow.getAttribute('data-setrow'), srow.querySelector('.mtwc-setname') ? srow.querySelector('.mtwc-setname').textContent : ''); return; }
    if (t.closest('[data-mtwc-mclose]')) { closeReceipt(); $$('[data-mtwc-modal]').forEach(function (m) { m.hidden = true; }); return; }
    if (t.closest('[data-mtwc-addcart]') || t.closest('[data-mtwc-dockcart]')) { addToCart(); return; }
    if (t.closest('[data-mtwc-docksum]')) { showTab('binder'); return; }
    var tab = t.closest('[data-mtwc-tab]'); if (tab) { showTab(tab.getAttribute('data-mtwc-tab')); return; }
  });
  // Mobilens faner: "search" eller "binder".
  function showTab(which) {
    $('[data-mtwc-stage]').classList.toggle('mtwc-show-binder', which === 'binder');
    $$('[data-mtwc-tab]').forEach(function (b) { b.classList.toggle('mtwc-on', b.getAttribute('data-mtwc-tab') === which); });
  }

  // Vælgerne: stand-grænsen i værktøjsrækken og standen på det enkelte kort. Et valg lægger aldrig noget i binderen.
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute) return;
    // Sortering og filtre i rækken under pillen: listen tegnes igen fra det hentede (intet kald, binderen røres ikke).
    var which = t.getAttribute('data-mtwc-arr');
    if (which) { arr[which] = t.value; redraw(true); return; }
    var isLimit = t.hasAttribute('data-mtwc-limitsel');
    if (!isLimit && !t.hasAttribute('data-standsel')) return;
    // Mens der lægges i kurven, ændres intet: vælgerne sættes tilbage til det, de viste.
    if (busy || asking) { paintLimit(); redraw(true); return; }
    if (isLimit) { setLimit(t.value); return; }
    var li = t.closest('.mtwc-result'), tile = li && tileOf(li.getAttribute('data-handle'), li.getAttribute('data-tile'));
    var v = tile && K.variantById(tile, t.value); // kun udgavens egne varianter
    // Kun en stand, der står i udgavens friske oversigt (på lager). Ellers er vælgeren ældre end data: sig det, og tegn listen igen.
    if (!v || !K.standSummary(tile).some(function (o) { return o.id === v.id; })) { toast(v && v.available ? MOVED_TEXT : SOLD_TEXT); redraw(true); return; }
    chosen[tile.handle + '|' + tile.key] = v.id;
    // Alle tegnede kort for udgaven følger valget (samme produkt kan stå flere gange i en liste).
    var same = drawnTiles(tile.handle, tile.key), n = same.indexOf(li);
    if (!waiting) { same.forEach(function (el) { paintTile(el, tile); }); paintAddAll(); return; }
    // En tegning har ventet på valget (se renderResults): tegn nu, og sæt fokus tilbage på kortets vælger.
    redraw(true);
    var again = drawnTiles(tile.handle, tile.key)[n], sel = again && again.querySelector('[data-standsel]');
    if (sel) sel.focus();
  });
  // Fokus har forladt et korts stand-vælger uden et valg: en tegning, der har ventet (se renderResults), køres. Lidt efter, så
  // trykket, der flyttede fokus (fx på et kort), rammer det kort, kunden så. Har en anden vælger fået fokus imens, ventes der videre.
  root.addEventListener('focusout', function (e) {
    if (waiting && e.target && e.target.hasAttribute && e.target.hasAttribute('data-standsel')) setTimeout(function () { if (waiting) redraw(); }, 300);
  });

  $('[data-mtwc-input]').addEventListener('input', function () {
    var v = this.value; clearTimeout(debT);
    lastResults = []; lastTerm = ''; // listen på skærmen hører ikke længere til teksten i feltet
    if (v.trim().length < MIN_CHARS) { showFeatured(); return; }
    setChipActive(null);
    debT = setTimeout(function () { search(v); }, DEBOUNCE);
  });
  $('[data-mtwc-input]').addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      // På touch lukker Enter kun tastaturet. Ellers: kun når listen hører til teksten i feltet.
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) { this.blur(); return; }
      if (!lastTerm || lastTerm !== this.value.trim()) return;
      // Kun det første synlige kort (skjulte kort springes over), og kun det, kortet viser som valgt. Viser det intet valg,
      // lægges intet i: Enter hopper aldrig videre til et andet kort eller en anden udgave.
      var lis = lastResults.length ? $$('.mtwc-result', $('[data-mtwc-results]')).filter(function (li) { return li.offsetParent !== null; }) : [];
      if (!lis.length) return;
      if (addShown(lis[0]) === 'intet') {
        var et = tileOf(lis[0].getAttribute('data-handle'), lis[0].getAttribute('data-tile'));
        toast(et && et.available ? 'Øverste kort er ikke i din stand-grænse. Vælg en stand på kortet.' : 'Øverste kort er udsolgt');
      }
    }
    else if (e.key === 'Escape') { closeApp(); }
  });
  var artistInp = $('[data-mtwc-artistinput]');
  if (artistInp) {
    var artistDeb = null;
    artistInp.addEventListener('input', function () { clearTimeout(artistDeb); artistDeb = setTimeout(renderArtistList, 120); });
    artistInp.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); $('[data-mtwc-modal="artists"]').hidden = true; } });
  }
  var setInp = $('[data-mtwc-setinput]');
  if (setInp) {
    var setDeb = null;
    setInp.addEventListener('input', function () { clearTimeout(setDeb); setDeb = setTimeout(renderSetList, 120); });
    setInp.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); $('[data-mtwc-modal="sets"]').hidden = true; } });
  }

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    var typing = document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA');
    if (e.key === 'Tab') { trapReceipt(e); return; }
    if (e.key === 'Escape') { var openM = $$('[data-mtwc-modal]').filter(function (m) { return !m.hidden; }); if (openM.length) { closeReceipt(); openM.forEach(function (m) { m.hidden = true; }); } else closeApp(); return; }
    if (typing) return;
    if (e.key === 'ArrowLeft') goToPage(cur - 1); else if (e.key === 'ArrowRight') goToPage(cur + 1);
  });

  /* ---------- reveal-on-scroll (landing-sektioner) ---------- */
  (function () {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- init ---------- */
  paintLimit();
  restore();
  // En gammel binder (v1) læses én gang: gem den i det nye format (uden nyt tidsstempel) og slet den gamle.
  try {
    if (localStorage.getItem(STORE_V1) !== null) { var first = K.serialize(items, savedAt); localStorage.setItem(STORE_V2, first); savedRaw = first; localStorage.removeItem(STORE_V1); }
  } catch (e) {}
  render();
  // Direkte link: åbn med det samme. Ellers må klassen fra sektionens script ikke blive stående og skjule landingssiden.
  if (direkte) openApp(true); else document.documentElement.classList.remove('mtwc-direkte');
})();

/* cache-rotation 2026-10-13 */
